// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/fonts.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/icons/close-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+PHBhdGggZD0iTTEgMS41bDUgNSA1LTUiIHN0cm9rZT0iIzk3OWE5ZiIgc3Ryb2tlLXdpZHRoPSIxLjYiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/icons/modalclose.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tailwind CSS - Required for PromotionIQ module */
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px){
  .container{
    max-width: 1400px;
  }
}
.sr-only{
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border-width: 0 !important;
}
.pointer-events-none{
  pointer-events: none !important;
}
.pointer-events-auto{
  pointer-events: auto !important;
}
.visible{
  visibility: visible !important;
}
.invisible{
  visibility: hidden !important;
}
.collapse{
  visibility: collapse !important;
}
.static{
  position: static !important;
}
.fixed{
  position: fixed !important;
}
.absolute{
  position: absolute !important;
}
.relative{
  position: relative !important;
}
.inset-0{
  inset: 0px !important;
}
.inset-4{
  inset: 1rem !important;
}
.inset-x-0{
  left: 0px !important;
  right: 0px !important;
}
.inset-y-0{
  top: 0px !important;
  bottom: 0px !important;
}
.-bottom-12{
  bottom: -3rem !important;
}
.-left-12{
  left: -3rem !important;
}
.-right-1\\.5{
  right: -0.375rem !important;
}
.-right-12{
  right: -3rem !important;
}
.-top-1\\.5{
  top: -0.375rem !important;
}
.-top-12{
  top: -3rem !important;
}
.bottom-0{
  bottom: 0px !important;
}
.bottom-4{
  bottom: 1rem !important;
}
.left-0{
  left: 0px !important;
}
.left-1{
  left: 0.25rem !important;
}
.left-1\\/2{
  left: 50% !important;
}
.left-2{
  left: 0.5rem !important;
}
.left-3{
  left: 0.75rem !important;
}
.left-\\[50\\%\\]{
  left: 50% !important;
}
.right-0{
  right: 0px !important;
}
.right-1{
  right: 0.25rem !important;
}
.right-2{
  right: 0.5rem !important;
}
.right-3{
  right: 0.75rem !important;
}
.right-4{
  right: 1rem !important;
}
.top-0{
  top: 0px !important;
}
.top-1\\/2{
  top: 50% !important;
}
.top-2{
  top: 0.5rem !important;
}
.top-3{
  top: 0.75rem !important;
}
.top-4{
  top: 1rem !important;
}
.top-\\[110px\\]{
  top: 110px !important;
}
.top-\\[1px\\]{
  top: 1px !important;
}
.top-\\[200px\\]{
  top: 200px !important;
}
.top-\\[50\\%\\]{
  top: 50% !important;
}
.top-\\[60\\%\\]{
  top: 60% !important;
}
.top-full{
  top: 100% !important;
}
.\\!z-\\[9999\\]{
  z-index: 9999 !important;
}
.z-10{
  z-index: 10 !important;
}
.z-40{
  z-index: 40 !important;
}
.z-50{
  z-index: 50 !important;
}
.z-\\[100\\]{
  z-index: 100 !important;
}
.z-\\[1\\]{
  z-index: 1 !important;
}
.order-1{
  order: 1 !important;
}
.order-2{
  order: 2 !important;
}
.order-3{
  order: 3 !important;
}
.order-4{
  order: 4 !important;
}
.order-5{
  order: 5 !important;
}
.order-6{
  order: 6 !important;
}
.col-span-2{
  grid-column: span 2 / span 2 !important;
}
.col-span-3{
  grid-column: span 3 / span 3 !important;
}
.col-span-4{
  grid-column: span 4 / span 4 !important;
}
.col-start-1{
  grid-column-start: 1 !important;
}
.col-start-2{
  grid-column-start: 2 !important;
}
.row-span-3{
  grid-row: span 3 / span 3 !important;
}
.row-span-5{
  grid-row: span 5 / span 5 !important;
}
.row-start-1{
  grid-row-start: 1 !important;
}
.row-start-2{
  grid-row-start: 2 !important;
}
.row-start-3{
  grid-row-start: 3 !important;
}
.float-end{
  float: inline-end !important;
}
.-mx-1{
  margin-left: -0.25rem !important;
  margin-right: -0.25rem !important;
}
.-mx-2{
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}
.mx-0{
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.mx-1{
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.mx-1\\.5{
  margin-left: 0.375rem !important;
  margin-right: 0.375rem !important;
}
.mx-5{
  margin-left: 1.25rem !important;
  margin-right: 1.25rem !important;
}
.mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-0\\.5{
  margin-top: 0.125rem !important;
  margin-bottom: 0.125rem !important;
}
.my-1{
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.\\!mt-\\[5\\.5rem\\]{
  margin-top: 5.5rem !important;
}
.-ml-4{
  margin-left: -1rem !important;
}
.-mt-2{
  margin-top: -0.5rem !important;
}
.-mt-4{
  margin-top: -1rem !important;
}
.mb-0{
  margin-bottom: 0px !important;
}
.mb-0\\.5{
  margin-bottom: 0.125rem !important;
}
.mb-1{
  margin-bottom: 0.25rem !important;
}
.mb-2{
  margin-bottom: 0.5rem !important;
}
.mb-3{
  margin-bottom: 0.75rem !important;
}
.mb-4{
  margin-bottom: 1rem !important;
}
.mb-5{
  margin-bottom: 1.25rem !important;
}
.mb-6{
  margin-bottom: 1.5rem !important;
}
.me-2{
  margin-inline-end: 0.5rem !important;
}
.me-4{
  margin-inline-end: 1rem !important;
}
.ml-0\\.5{
  margin-left: 0.125rem !important;
}
.ml-1{
  margin-left: 0.25rem !important;
}
.ml-1\\.5{
  margin-left: 0.375rem !important;
}
.ml-2{
  margin-left: 0.5rem !important;
}
.ml-3{
  margin-left: 0.75rem !important;
}
.ml-4{
  margin-left: 1rem !important;
}
.ml-7{
  margin-left: 1.75rem !important;
}
.ml-auto{
  margin-left: auto !important;
}
.mr-1{
  margin-right: 0.25rem !important;
}
.mr-1\\.5{
  margin-right: 0.375rem !important;
}
.mr-2{
  margin-right: 0.5rem !important;
}
.mr-3{
  margin-right: 0.75rem !important;
}
.ms-0{
  margin-inline-start: 0px !important;
}
.ms-2{
  margin-inline-start: 0.5rem !important;
}
.ms-3{
  margin-inline-start: 0.75rem !important;
}
.ms-4{
  margin-inline-start: 1rem !important;
}
.mt-0{
  margin-top: 0px !important;
}
.mt-0\\.5{
  margin-top: 0.125rem !important;
}
.mt-1{
  margin-top: 0.25rem !important;
}
.mt-1\\.5{
  margin-top: 0.375rem !important;
}
.mt-12{
  margin-top: 3rem !important;
}
.mt-2{
  margin-top: 0.5rem !important;
}
.mt-24{
  margin-top: 6rem !important;
}
.mt-3{
  margin-top: 0.75rem !important;
}
.mt-4{
  margin-top: 1rem !important;
}
.mt-5{
  margin-top: 1.25rem !important;
}
.mt-6{
  margin-top: 1.5rem !important;
}
.mt-8{
  margin-top: 2rem !important;
}
.mt-auto{
  margin-top: auto !important;
}
.-mb-4{
  margin-bottom: -1rem !important;
}
.block{
  display: block !important;
}
.inline-block{
  display: inline-block !important;
}
.inline{
  display: inline !important;
}
.flex{
  display: flex !important;
}
.inline-flex{
  display: inline-flex !important;
}
.\\!table{
  display: table !important;
}
.table{
  display: table !important;
}
.table-cell{
  display: table-cell !important;
}
.grid{
  display: grid !important;
}
.contents{
  display: contents !important;
}
.hidden{
  display: none !important;
}
.aspect-square{
  aspect-ratio: 1 / 1 !important;
}
.aspect-video{
  aspect-ratio: 16 / 9 !important;
}
.size-2{
  width: 0.5rem !important;
  height: 0.5rem !important;
}
.size-2\\.5{
  width: 0.625rem !important;
  height: 0.625rem !important;
}
.size-3{
  width: 0.75rem !important;
  height: 0.75rem !important;
}
.size-3\\.5{
  width: 0.875rem !important;
  height: 0.875rem !important;
}
.size-4{
  width: 1rem !important;
  height: 1rem !important;
}
.size-5{
  width: 1.25rem !important;
  height: 1.25rem !important;
}
.size-6{
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.size-8{
  width: 2rem !important;
  height: 2rem !important;
}
.h-0\\.5{
  height: 0.125rem !important;
}
.h-1\\.5{
  height: 0.375rem !important;
}
.h-10{
  height: 2.5rem !important;
}
.h-11{
  height: 2.75rem !important;
}
.h-12{
  height: 3rem !important;
}
.h-16{
  height: 4rem !important;
}
.h-2{
  height: 0.5rem !important;
}
.h-2\\.5{
  height: 0.625rem !important;
}
.h-20{
  height: 5rem !important;
}
.h-24{
  height: 6rem !important;
}
.h-28{
  height: 7rem !important;
}
.h-3{
  height: 0.75rem !important;
}
.h-3\\.5{
  height: 0.875rem !important;
}
.h-32{
  height: 8rem !important;
}
.h-36{
  height: 9rem !important;
}
.h-4{
  height: 1rem !important;
}
.h-40{
  height: 10rem !important;
}
.h-48{
  height: 12rem !important;
}
.h-5{
  height: 1.25rem !important;
}
.h-52{
  height: 13rem !important;
}
.h-6{
  height: 1.5rem !important;
}
.h-60{
  height: 15rem !important;
}
.h-64{
  height: 16rem !important;
}
.h-7{
  height: 1.75rem !important;
}
.h-72{
  height: 18rem !important;
}
.h-8{
  height: 2rem !important;
}
.h-80{
  height: 20rem !important;
}
.h-9{
  height: 2.25rem !important;
}
.h-96{
  height: 24rem !important;
}
.h-\\[120px\\]{
  height: 120px !important;
}
.h-\\[132px\\]{
  height: 132px !important;
}
.h-\\[1px\\]{
  height: 1px !important;
}
.h-\\[220px\\]{
  height: 220px !important;
}
.h-\\[260px\\]{
  height: 260px !important;
}
.h-\\[280px\\]{
  height: 280px !important;
}
.h-\\[2px\\]{
  height: 2px !important;
}
.h-\\[300px\\]{
  height: 300px !important;
}
.h-\\[320px\\]{
  height: 320px !important;
}
.h-\\[340px\\]{
  height: 340px !important;
}
.h-\\[34px\\]{
  height: 34px !important;
}
.h-\\[360px\\]{
  height: 360px !important;
}
.h-\\[400px\\]{
  height: 400px !important;
}
.h-\\[420px\\]{
  height: 420px !important;
}
.h-\\[460px\\]{
  height: 460px !important;
}
.h-\\[520px\\]{
  height: 520px !important;
}
.h-\\[52px\\]{
  height: 52px !important;
}
.h-\\[560px\\]{
  height: 560px !important;
}
.h-\\[70px\\]{
  height: 70px !important;
}
.h-\\[90px\\]{
  height: 90px !important;
}
.h-\\[92px\\]{
  height: 92px !important;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height) !important;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height) !important;
}
.h-auto{
  height: auto !important;
}
.h-full{
  height: 100% !important;
}
.h-px{
  height: 1px !important;
}
.h-screen{
  height: 100vh !important;
}
.max-h-48{
  max-height: 12rem !important;
}
.max-h-56{
  max-height: 14rem !important;
}
.max-h-64{
  max-height: 16rem !important;
}
.max-h-72{
  max-height: 18rem !important;
}
.max-h-96{
  max-height: 24rem !important;
}
.max-h-\\[300px\\]{
  max-height: 300px !important;
}
.max-h-\\[320px\\]{
  max-height: 320px !important;
}
.max-h-\\[82vh\\]{
  max-height: 82vh !important;
}
.max-h-\\[85vh\\]{
  max-height: 85vh !important;
}
.max-h-\\[86vh\\]{
  max-height: 86vh !important;
}
.max-h-\\[90vh\\]{
  max-height: 90vh !important;
}
.max-h-screen{
  max-height: 100vh !important;
}
.max-h-\\[32rem\\]{
  max-height: 32rem !important;
}
.min-h-0{
  min-height: 0px !important;
}
.min-h-20{
  min-height: 5rem !important;
}
.min-h-24{
  min-height: 6rem !important;
}
.min-h-64{
  min-height: 16rem !important;
}
.min-h-\\[100px\\]{
  min-height: 100px !important;
}
.min-h-\\[110px\\]{
  min-height: 110px !important;
}
.min-h-\\[60vh\\]{
  min-height: 60vh !important;
}
.min-h-\\[64px\\]{
  min-height: 64px !important;
}
.min-h-\\[80px\\]{
  min-height: 80px !important;
}
.min-h-screen{
  min-height: 100vh !important;
}
.w-0{
  width: 0px !important;
}
.w-1{
  width: 0.25rem !important;
}
.w-1\\.5{
  width: 0.375rem !important;
}
.w-1\\/3{
  width: 33.333333% !important;
}
.w-10{
  width: 2.5rem !important;
}
.w-11{
  width: 2.75rem !important;
}
.w-16{
  width: 4rem !important;
}
.w-2{
  width: 0.5rem !important;
}
.w-2\\.5{
  width: 0.625rem !important;
}
.w-20{
  width: 5rem !important;
}
.w-24{
  width: 6rem !important;
}
.w-28{
  width: 7rem !important;
}
.w-3{
  width: 0.75rem !important;
}
.w-3\\.5{
  width: 0.875rem !important;
}
.w-3\\/4{
  width: 75% !important;
}
.w-32{
  width: 8rem !important;
}
.w-36{
  width: 9rem !important;
}
.w-4{
  width: 1rem !important;
}
.w-40{
  width: 10rem !important;
}
.w-48{
  width: 12rem !important;
}
.w-5{
  width: 1.25rem !important;
}
.w-52{
  width: 13rem !important;
}
.w-56{
  width: 14rem !important;
}
.w-6{
  width: 1.5rem !important;
}
.w-64{
  width: 16rem !important;
}
.w-7{
  width: 1.75rem !important;
}
.w-72{
  width: 18rem !important;
}
.w-8{
  width: 2rem !important;
}
.w-80{
  width: 20rem !important;
}
.w-9{
  width: 2.25rem !important;
}
.w-\\[10\\%\\]{
  width: 10% !important;
}
.w-\\[100px\\]{
  width: 100px !important;
}
.w-\\[105px\\]{
  width: 105px !important;
}
.w-\\[110px\\]{
  width: 110px !important;
}
.w-\\[12\\%\\]{
  width: 12% !important;
}
.w-\\[120px\\]{
  width: 120px !important;
}
.w-\\[130px\\]{
  width: 130px !important;
}
.w-\\[14\\%\\]{
  width: 14% !important;
}
.w-\\[140px\\]{
  width: 140px !important;
}
.w-\\[15\\%\\]{
  width: 15% !important;
}
.w-\\[150px\\]{
  width: 150px !important;
}
.w-\\[16\\%\\]{
  width: 16% !important;
}
.w-\\[160px\\]{
  width: 160px !important;
}
.w-\\[168px\\]{
  width: 168px !important;
}
.w-\\[170px\\]{
  width: 170px !important;
}
.w-\\[180px\\]{
  width: 180px !important;
}
.w-\\[1px\\]{
  width: 1px !important;
}
.w-\\[200px\\]{
  width: 200px !important;
}
.w-\\[220px\\]{
  width: 220px !important;
}
.w-\\[230px\\]{
  width: 230px !important;
}
.w-\\[240px\\]{
  width: 240px !important;
}
.w-\\[25\\%\\]{
  width: 25% !important;
}
.w-\\[2px\\]{
  width: 2px !important;
}
.w-\\[300px\\]{
  width: 300px !important;
}
.w-\\[32\\%\\]{
  width: 32% !important;
}
.w-\\[3px\\]{
  width: 3px !important;
}
.w-\\[7\\%\\]{
  width: 7% !important;
}
.w-\\[8\\%\\]{
  width: 8% !important;
}
.w-\\[9\\%\\]{
  width: 9% !important;
}
.w-\\[90px\\]{
  width: 90px !important;
}
.w-auto{
  width: auto !important;
}
.w-fit{
  width: fit-content !important;
}
.w-full{
  width: 100% !important;
}
.w-max{
  width: max-content !important;
}
.w-px{
  width: 1px !important;
}
.w-12{
  width: 3rem !important;
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\]{
  width: var(--radix-popover-trigger-width) !important;
}
.min-w-0{
  min-width: 0px !important;
}
.min-w-\\[1000px\\]{
  min-width: 1000px !important;
}
.min-w-\\[100px\\]{
  min-width: 100px !important;
}
.min-w-\\[1100px\\]{
  min-width: 1100px !important;
}
.min-w-\\[110px\\]{
  min-width: 110px !important;
}
.min-w-\\[120px\\]{
  min-width: 120px !important;
}
.min-w-\\[12rem\\]{
  min-width: 12rem !important;
}
.min-w-\\[130px\\]{
  min-width: 130px !important;
}
.min-w-\\[1320px\\]{
  min-width: 1320px !important;
}
.min-w-\\[1360px\\]{
  min-width: 1360px !important;
}
.min-w-\\[150px\\]{
  min-width: 150px !important;
}
.min-w-\\[1520px\\]{
  min-width: 1520px !important;
}
.min-w-\\[160px\\]{
  min-width: 160px !important;
}
.min-w-\\[16px\\]{
  min-width: 16px !important;
}
.min-w-\\[16rem\\]{
  min-width: 16rem !important;
}
.min-w-\\[18rem\\]{
  min-width: 18rem !important;
}
.min-w-\\[200px\\]{
  min-width: 200px !important;
}
.min-w-\\[720px\\]{
  min-width: 720px !important;
}
.min-w-\\[74px\\]{
  min-width: 74px !important;
}
.min-w-\\[820px\\]{
  min-width: 820px !important;
}
.min-w-\\[84px\\]{
  min-width: 84px !important;
}
.min-w-\\[860px\\]{
  min-width: 860px !important;
}
.min-w-\\[8rem\\]{
  min-width: 8rem !important;
}
.min-w-\\[900px\\]{
  min-width: 900px !important;
}
.min-w-\\[960px\\]{
  min-width: 960px !important;
}
.min-w-\\[980px\\]{
  min-width: 980px !important;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width) !important;
}
.min-w-max{
  min-width: max-content !important;
}
.min-w-\\[640px\\]{
  min-width: 640px !important;
}
.min-w-\\[1200px\\]{
  min-width: 1200px !important;
}
.min-w-\\[128px\\]{
  min-width: 128px !important;
}
.min-w-\\[280px\\]{
  min-width: 280px !important;
}
.max-w-24{
  max-width: 6rem !important;
}
.max-w-2xl{
  max-width: 42rem !important;
}
.max-w-3xl{
  max-width: 48rem !important;
}
.max-w-4xl{
  max-width: 56rem !important;
}
.max-w-6xl{
  max-width: 72rem !important;
}
.max-w-7xl{
  max-width: 80rem !important;
}
.max-w-\\[220px\\]{
  max-width: 220px !important;
}
.max-w-\\[22rem\\]{
  max-width: 22rem !important;
}
.max-w-\\[240px\\]{
  max-width: 240px !important;
}
.max-w-\\[260px\\]{
  max-width: 260px !important;
}
.max-w-\\[280px\\]{
  max-width: 280px !important;
}
.max-w-\\[300px\\]{
  max-width: 300px !important;
}
.max-w-\\[340px\\]{
  max-width: 340px !important;
}
.max-w-full{
  max-width: 100% !important;
}
.max-w-lg{
  max-width: 32rem !important;
}
.max-w-max{
  max-width: max-content !important;
}
.max-w-md{
  max-width: 28rem !important;
}
.max-w-sm{
  max-width: 24rem !important;
}
.max-w-xl{
  max-width: 36rem !important;
}
.max-w-xs{
  max-width: 20rem !important;
}
.max-w-\\[200px\\]{
  max-width: 200px !important;
}
.flex-1{
  flex: 1 1 !important;
}
.shrink{
  flex-shrink: 1 !important;
}
.shrink-0{
  flex-shrink: 0 !important;
}
.grow{
  flex-grow: 1 !important;
}
.grow-0{
  flex-grow: 0 !important;
}
.basis-full{
  flex-basis: 100% !important;
}
.table-fixed{
  table-layout: fixed !important;
}
.caption-bottom{
  caption-side: bottom !important;
}
.border-collapse{
  border-collapse: collapse !important;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2{
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180{
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-45{
  --tw-rotate: 45deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-90{
  --tw-rotate: 90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes fade-in{
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}
.animate-fade-in{
  animation: fade-in 200ms ease-out !important;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite !important;
}
.cursor-default{
  cursor: default !important;
}
.cursor-help{
  cursor: help !important;
}
.cursor-not-allowed{
  cursor: not-allowed !important;
}
.cursor-pointer{
  cursor: pointer !important;
}
.cursor-grab{
  cursor: grab !important;
}
.touch-none{
  touch-action: none !important;
}
.select-none{
  -webkit-user-select: none !important;
          user-select: none !important;
}
.select-all{
  -webkit-user-select: all !important;
          user-select: all !important;
}
.resize{
  resize: both !important;
}
.scroll-mt-\\[200px\\]{
  scroll-margin-top: 200px !important;
}
.list-none{
  list-style-type: none !important;
}
.auto-cols-\\[minmax\\(160px\\2c 1fr\\)\\]{
  grid-auto-columns: minmax(160px,1fr) !important;
}
.auto-cols-\\[minmax\\(160px\\2c auto\\)\\]{
  grid-auto-columns: minmax(160px,auto) !important;
}
.grid-flow-col{
  grid-auto-flow: column !important;
}
.auto-rows-fr{
  grid-auto-rows: minmax(0, 1fr) !important;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}
.grid-cols-\\[1\\.3fr_2fr_2fr\\]{
  grid-template-columns: 1.3fr 2fr 2fr !important;
}
.grid-cols-\\[1fr_1fr_8rem_8rem_2\\.25rem\\]{
  grid-template-columns: 1fr 1fr 8rem 8rem 2.25rem !important;
}
.grid-cols-\\[8rem_9rem_1fr\\]{
  grid-template-columns: 8rem 9rem 1fr !important;
}
.grid-cols-\\[1rem_minmax\\(0\\2c 1fr\\)_1\\.5rem_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 1rem minmax(0,1fr) 1.5rem minmax(0,1fr) !important;
}
.grid-cols-\\[1fr_auto\\]{
  grid-template-columns: 1fr auto !important;
}
.grid-rows-\\[auto_auto_auto\\]{
  grid-template-rows: auto auto auto !important;
}
.flex-row{
  flex-direction: row !important;
}
.flex-row-reverse{
  flex-direction: row-reverse !important;
}
.flex-col{
  flex-direction: column !important;
}
.flex-col-reverse{
  flex-direction: column-reverse !important;
}
.flex-wrap{
  flex-wrap: wrap !important;
}
.flex-nowrap{
  flex-wrap: nowrap !important;
}
.place-items-center{
  place-items: center !important;
}
.items-start{
  align-items: flex-start !important;
}
.items-end{
  align-items: flex-end !important;
}
.items-center{
  align-items: center !important;
}
.items-baseline{
  align-items: baseline !important;
}
.items-stretch{
  align-items: stretch !important;
}
.justify-start{
  justify-content: flex-start !important;
}
.justify-end{
  justify-content: flex-end !important;
}
.justify-center{
  justify-content: center !important;
}
.justify-between{
  justify-content: space-between !important;
}
.gap-0{
  gap: 0px !important;
}
.gap-0\\.5{
  gap: 0.125rem !important;
}
.gap-1{
  gap: 0.25rem !important;
}
.gap-1\\.5{
  gap: 0.375rem !important;
}
.gap-2{
  gap: 0.5rem !important;
}
.gap-3{
  gap: 0.75rem !important;
}
.gap-4{
  gap: 1rem !important;
}
.gap-5{
  gap: 1.25rem !important;
}
.gap-6{
  gap: 1.5rem !important;
}
.gap-8{
  gap: 2rem !important;
}
.gap-x-4{
  column-gap: 1rem !important;
}
.gap-x-6{
  column-gap: 1.5rem !important;
}
.gap-x-8{
  column-gap: 2rem !important;
}
.gap-y-0{
  row-gap: 0px !important;
}
.gap-y-1{
  row-gap: 0.25rem !important;
}
.gap-y-2{
  row-gap: 0.5rem !important;
}
.gap-y-3{
  row-gap: 0.75rem !important;
}
.gap-x-5{
  column-gap: 1.25rem !important;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse)) !important;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse)) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(2rem * var(--tw-space-y-reverse)) !important;
}
.space-y-\\[10px\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(10px * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(10px * var(--tw-space-y-reverse)) !important;
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0 !important;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse))) !important;
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse)) !important;
}
.divide-border > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border)) !important;
}
.divide-border\\/60 > :not([hidden]) ~ :not([hidden]){
  border-color: hsl(var(--border) / 0.6) !important;
}
.self-start{
  align-self: flex-start !important;
}
.overflow-auto{
  overflow: auto !important;
}
.overflow-hidden{
  overflow: hidden !important;
}
.overflow-x-auto{
  overflow-x: auto !important;
}
.overflow-y-auto{
  overflow-y: auto !important;
}
.overflow-x-hidden{
  overflow-x: hidden !important;
}
.scroll-smooth{
  scroll-behavior: smooth !important;
}
.truncate{
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.whitespace-nowrap{
  white-space: nowrap !important;
}
.whitespace-pre{
  white-space: pre !important;
}
.whitespace-pre-line{
  white-space: pre-line !important;
}
.whitespace-pre-wrap{
  white-space: pre-wrap !important;
}
.break-words{
  overflow-wrap: break-word !important;
}
.rounded{
  border-radius: 0.25rem !important;
}
.rounded-\\[2px\\]{
  border-radius: 2px !important;
}
.rounded-\\[3px\\]{
  border-radius: 3px !important;
}
.rounded-\\[inherit\\]{
  border-radius: inherit !important;
}
.rounded-full{
  border-radius: 9999px !important;
}
.rounded-lg{
  border-radius: 0px !important;
}
.rounded-md{
  border-radius: 0px !important;
}
.rounded-sm{
  border-radius: 0px !important;
}
.rounded-xl{
  border-radius: 0.75rem !important;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}
.rounded-tl-sm{
  border-top-left-radius: 0px !important;
}
.\\!border-0{
  border-width: 0px !important;
}
.border{
  border-width: 1px !important;
}
.border-0{
  border-width: 0px !important;
}
.border-2{
  border-width: 2px !important;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px !important;
}
.border-y{
  border-top-width: 1px !important;
  border-bottom-width: 1px !important;
}
.border-b{
  border-bottom-width: 1px !important;
}
.border-b-0{
  border-bottom-width: 0px !important;
}
.border-l{
  border-left-width: 1px !important;
}
.border-r{
  border-right-width: 1px !important;
}
.border-t{
  border-top-width: 1px !important;
}
.border-t-2{
  border-top-width: 2px !important;
}
.border-dashed{
  border-style: dashed !important;
}
.border-\\[--color-border\\]{
  border-color: var(--color-border) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 24\\%\\)\\]{
  --tw-border-opacity: 1 !important;
  border-color: hsl(216 11% 24% / var(--tw-border-opacity, 1)) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 26\\%\\)\\]{
  --tw-border-opacity: 1 !important;
  border-color: hsl(216 11% 26% / var(--tw-border-opacity, 1)) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 28\\%\\)\\]{
  --tw-border-opacity: 1 !important;
  border-color: hsl(216 11% 28% / var(--tw-border-opacity, 1)) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 30\\%\\)\\]{
  --tw-border-opacity: 1 !important;
  border-color: hsl(216 11% 30% / var(--tw-border-opacity, 1)) !important;
}
.border-blue-400{
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}
.border-border{
  border-color: hsl(var(--border)) !important;
}
.border-border\\/20{
  border-color: hsl(var(--border) / 0.2) !important;
}
.border-border\\/30{
  border-color: hsl(var(--border) / 0.3) !important;
}
.border-border\\/40{
  border-color: hsl(var(--border) / 0.4) !important;
}
.border-border\\/50{
  border-color: hsl(var(--border) / 0.5) !important;
}
.border-border\\/60{
  border-color: hsl(var(--border) / 0.6) !important;
}
.border-border\\/70{
  border-color: hsl(var(--border) / 0.7) !important;
}
.border-destructive{
  border-color: hsl(var(--destructive)) !important;
}
.border-destructive\\/40{
  border-color: hsl(var(--destructive) / 0.4) !important;
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5) !important;
}
.border-destructive\\/60{
  border-color: hsl(var(--destructive) / 0.6) !important;
}
.border-foreground{
  border-color: hsl(var(--foreground)) !important;
}
.border-foreground\\/50{
  border-color: hsl(var(--foreground) / 0.5) !important;
}
.border-input{
  border-color: hsl(var(--input)) !important;
}
.border-muted-foreground{
  border-color: hsl(var(--muted-foreground)) !important;
}
.border-muted-foreground\\/40{
  border-color: hsl(var(--muted-foreground) / 0.4) !important;
}
.border-muted-foreground\\/50{
  border-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.border-primary{
  border-color: hsl(var(--primary)) !important;
}
.border-primary\\/25{
  border-color: hsl(var(--primary) / 0.25) !important;
}
.border-primary\\/30{
  border-color: hsl(var(--primary) / 0.3) !important;
}
.border-primary\\/40{
  border-color: hsl(var(--primary) / 0.4) !important;
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5) !important;
}
.border-primary\\/60{
  border-color: hsl(var(--primary) / 0.6) !important;
}
.border-red-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1)) !important;
}
.border-secondary-foreground\\/60{
  border-color: hsl(var(--secondary-foreground) / 0.6) !important;
}
.border-success{
  border-color: hsl(var(--success)) !important;
}
.border-transparent{
  border-color: transparent !important;
}
.border-l-transparent{
  border-left-color: transparent !important;
}
.border-t-transparent{
  border-top-color: transparent !important;
}
.bg-\\[--color-bg\\]{
  background-color: var(--color-bg) !important;
}
.bg-\\[color-mix\\(in_oklch\\2c var\\(--approve\\)_18\\%\\2c transparent\\)\\]{
  background-color: color-mix(in oklch,var(--approve) 18%,transparent) !important;
}
.bg-\\[color-mix\\(in_oklch\\2c var\\(--decline\\)_18\\%\\2c transparent\\)\\]{
  background-color: color-mix(in oklch,var(--decline) 18%,transparent) !important;
}
.bg-\\[hsl\\(216\\2c 11\\%\\2c 13\\%\\)\\]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(216 11% 13% / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[hsl\\(216\\2c 11\\%\\2c 14\\%\\)\\]{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(216 11% 14% / var(--tw-bg-opacity, 1)) !important;
}
.bg-accent{
  background-color: hsl(var(--accent)) !important;
}
.bg-amber{
  background-color: var(--amber) !important;
}
.bg-amber-dim{
  background-color: var(--amber-dim) !important;
}
.bg-approve{
  background-color: var(--approve) !important;
}
.bg-background{
  background-color: hsl(var(--background)) !important;
}
.bg-background\\/40{
  background-color: hsl(var(--background) / 0.4) !important;
}
.bg-background\\/45{
  background-color: hsl(var(--background) / 0.45) !important;
}
.bg-background\\/50{
  background-color: hsl(var(--background) / 0.5) !important;
}
.bg-background\\/60{
  background-color: hsl(var(--background) / 0.6) !important;
}
.bg-background\\/95{
  background-color: hsl(var(--background) / 0.95) !important;
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5) !important;
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8) !important;
}
.bg-blue-400\\/10{
  background-color: rgb(96 165 250 / 0.1) !important;
}
.bg-border{
  background-color: hsl(var(--border)) !important;
}
.bg-card{
  background-color: hsl(var(--card)) !important;
}
.bg-card\\/40{
  background-color: hsl(var(--card) / 0.4) !important;
}
.bg-card\\/60{
  background-color: hsl(var(--card) / 0.6) !important;
}
.bg-decline{
  background-color: var(--decline) !important;
}
.bg-destructive{
  background-color: hsl(var(--destructive)) !important;
}
.bg-destructive\\/10{
  background-color: hsl(var(--destructive) / 0.1) !important;
}
.bg-destructive\\/15{
  background-color: hsl(var(--destructive) / 0.15) !important;
}
.bg-destructive\\/5{
  background-color: hsl(var(--destructive) / 0.05) !important;
}
.bg-foreground{
  background-color: hsl(var(--foreground)) !important;
}
.bg-foreground\\/5{
  background-color: hsl(var(--foreground) / 0.05) !important;
}
.bg-muted{
  background-color: hsl(var(--muted)) !important;
}
.bg-muted-foreground\\/50{
  background-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.bg-muted\\/10{
  background-color: hsl(var(--muted) / 0.1) !important;
}
.bg-muted\\/20{
  background-color: hsl(var(--muted) / 0.2) !important;
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3) !important;
}
.bg-muted\\/40{
  background-color: hsl(var(--muted) / 0.4) !important;
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5) !important;
}
.bg-neutral-inactive{
  background-color: var(--neutral-inactive) !important;
}
.bg-neutral-inactive-dim{
  background-color: var(--neutral-inactive-dim) !important;
}
.bg-popover{
  background-color: hsl(var(--popover)) !important;
}
.bg-primary{
  background-color: hsl(var(--primary)) !important;
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1) !important;
}
.bg-primary\\/15{
  background-color: hsl(var(--primary) / 0.15) !important;
}
.bg-primary\\/35{
  background-color: hsl(var(--primary) / 0.35) !important;
}
.bg-primary\\/5{
  background-color: hsl(var(--primary) / 0.05) !important;
}
.bg-red-950\\/30{
  background-color: rgb(69 10 10 / 0.3) !important;
}
.bg-secondary{
  background-color: hsl(var(--secondary)) !important;
}
.bg-secondary\\/20{
  background-color: hsl(var(--secondary) / 0.2) !important;
}
.bg-secondary\\/30{
  background-color: hsl(var(--secondary) / 0.3) !important;
}
.bg-secondary\\/40{
  background-color: hsl(var(--secondary) / 0.4) !important;
}
.bg-secondary\\/50{
  background-color: hsl(var(--secondary) / 0.5) !important;
}
.bg-secondary\\/60{
  background-color: hsl(var(--secondary) / 0.6) !important;
}
.bg-success\\/10{
  background-color: hsl(var(--success) / 0.1) !important;
}
.bg-success\\/15{
  background-color: hsl(var(--success) / 0.15) !important;
}
.bg-success\\/20{
  background-color: hsl(var(--success) / 0.2) !important;
}
.bg-success\\/5{
  background-color: hsl(var(--success) / 0.05) !important;
}
.bg-transparent{
  background-color: transparent !important;
}
.bg-warning\\/10{
  background-color: hsl(var(--warning) / 0.1) !important;
}
.bg-warning\\/15{
  background-color: hsl(var(--warning) / 0.15) !important;
}
.bg-warning\\/5{
  background-color: hsl(var(--warning) / 0.05) !important;
}
.fill-current{
  fill: currentColor !important;
}
.p-0{
  padding: 0px !important;
}
.p-0\\.5{
  padding: 0.125rem !important;
}
.p-1{
  padding: 0.25rem !important;
}
.p-1\\.5{
  padding: 0.375rem !important;
}
.p-2{
  padding: 0.5rem !important;
}
.p-2\\.5{
  padding: 0.625rem !important;
}
.p-3{
  padding: 0.75rem !important;
}
.p-4{
  padding: 1rem !important;
}
.p-5{
  padding: 1.25rem !important;
}
.p-6{
  padding: 1.5rem !important;
}
.p-8{
  padding: 2rem !important;
}
.p-\\[1px\\]{
  padding: 1px !important;
}
.px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-1\\.5{
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}
.px-10{
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-2\\.5{
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}
.px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.py-0{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.py-0\\.5{
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-1\\.5{
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.py-10{
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.py-12{
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.py-14{
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}
.py-16{
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
.py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-2\\.5{
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-3\\.5{
  padding-top: 0.875rem !important;
  padding-bottom: 0.875rem !important;
}
.py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5{
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-6{
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.pb-0{
  padding-bottom: 0px !important;
}
.pb-0\\.5{
  padding-bottom: 0.125rem !important;
}
.pb-16{
  padding-bottom: 4rem !important;
}
.pb-2{
  padding-bottom: 0.5rem !important;
}
.pb-24{
  padding-bottom: 6rem !important;
}
.pb-3{
  padding-bottom: 0.75rem !important;
}
.pb-4{
  padding-bottom: 1rem !important;
}
.pb-6{
  padding-bottom: 1.5rem !important;
}
.pb-7{
  padding-bottom: 1.75rem !important;
}
.pb-8{
  padding-bottom: 2rem !important;
}
.pb-\\[80px\\]{
  padding-bottom: 80px !important;
}
.pe-4{
  padding-inline-end: 1rem !important;
}
.pl-12{
  padding-left: 3rem !important;
}
.pl-2\\.5{
  padding-left: 0.625rem !important;
}
.pl-3{
  padding-left: 0.75rem !important;
}
.pl-4{
  padding-left: 1rem !important;
}
.pl-40{
  padding-left: 10rem !important;
}
.pl-6{
  padding-left: 1.5rem !important;
}
.pl-7{
  padding-left: 1.75rem !important;
}
.pl-8{
  padding-left: 2rem !important;
}
.pr-0{
  padding-right: 0px !important;
}
.pr-1{
  padding-right: 0.25rem !important;
}
.pr-2{
  padding-right: 0.5rem !important;
}
.pr-2\\.5{
  padding-right: 0.625rem !important;
}
.pr-3{
  padding-right: 0.75rem !important;
}
.pr-4{
  padding-right: 1rem !important;
}
.pr-6{
  padding-right: 1.5rem !important;
}
.pr-64{
  padding-right: 16rem !important;
}
.pr-7{
  padding-right: 1.75rem !important;
}
.pr-8{
  padding-right: 2rem !important;
}
.ps-2{
  padding-inline-start: 0.5rem !important;
}
.pt-0{
  padding-top: 0px !important;
}
.pt-0\\.5{
  padding-top: 0.125rem !important;
}
.pt-1{
  padding-top: 0.25rem !important;
}
.pt-2{
  padding-top: 0.5rem !important;
}
.pt-24{
  padding-top: 6rem !important;
}
.pt-3{
  padding-top: 0.75rem !important;
}
.pt-4{
  padding-top: 1rem !important;
}
.pt-6{
  padding-top: 1.5rem !important;
}
.pt-7{
  padding-top: 1.75rem !important;
}
.pt-8{
  padding-top: 2rem !important;
}
.pt-\\[110px\\]{
  padding-top: 110px !important;
}
.pt-\\[14px\\]{
  padding-top: 14px !important;
}
.pt-\\[175px\\]{
  padding-top: 175px !important;
}
.pt-\\[200px\\]{
  padding-top: 200px !important;
}
.pb-1\\.5{
  padding-bottom: 0.375rem !important;
}
.pl-5{
  padding-left: 1.25rem !important;
}
.text-left{
  text-align: left !important;
}
.text-center{
  text-align: center !important;
}
.text-right{
  text-align: right !important;
}
.text-end{
  text-align: end !important;
}
.align-top{
  vertical-align: top !important;
}
.align-middle{
  vertical-align: middle !important;
}
.align-bottom{
  vertical-align: bottom !important;
}
.align-super{
  vertical-align: super !important;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}
.text-2xl{
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-3xl{
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-5xl{
  font-size: 3rem !important;
  line-height: 1 !important;
}
.text-\\[0\\.6rem\\]{
  font-size: 0.6rem !important;
}
.text-\\[0\\.7rem\\]{
  font-size: 0.7rem !important;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem !important;
}
.text-\\[10px\\]{
  font-size: 10px !important;
}
.text-\\[11px\\]{
  font-size: 11px !important;
}
.text-\\[26px\\]{
  font-size: 26px !important;
}
.text-\\[9px\\]{
  font-size: 9px !important;
}
.text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg{
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-bold{
  font-weight: 700 !important;
}
.font-medium{
  font-weight: 500 !important;
}
.font-normal{
  font-weight: 400 !important;
}
.font-semibold{
  font-weight: 600 !important;
}
.uppercase{
  text-transform: uppercase !important;
}
.lowercase{
  text-transform: lowercase !important;
}
.capitalize{
  text-transform: capitalize !important;
}
.normal-case{
  text-transform: none !important;
}
.italic{
  font-style: italic !important;
}
.ordinal{
  --tw-ordinal: ordinal !important;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums !important;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.leading-5{
  line-height: 1.25rem !important;
}
.leading-none{
  line-height: 1 !important;
}
.leading-relaxed{
  line-height: 1.625 !important;
}
.leading-snug{
  line-height: 1.375 !important;
}
.leading-tight{
  line-height: 1.25 !important;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em !important;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em !important;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em !important;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em !important;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em !important;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em !important;
}
.tracking-\\[0\\.1em\\]{
  letter-spacing: 0.1em !important;
}
.tracking-normal{
  letter-spacing: 0em !important;
}
.tracking-tight{
  letter-spacing: -0.025em !important;
}
.tracking-wide{
  letter-spacing: 0.025em !important;
}
.tracking-wider{
  letter-spacing: 0.05em !important;
}
.tracking-widest{
  letter-spacing: 0.1em !important;
}
.\\!text-primary{
  color: hsl(var(--primary)) !important;
}
.text-\\[color\\:var\\(--approve\\)\\]{
  color: var(--approve) !important;
}
.text-\\[color\\:var\\(--colorYellow\\)\\]{
  color: var(--colorYellow) !important;
}
.text-\\[color\\:var\\(--decline\\)\\]{
  color: var(--decline) !important;
}
.text-\\[hsl\\(30\\2c 9\\%\\2c 95\\%\\)\\]{
  --tw-text-opacity: 1 !important;
  color: hsl(30 9% 95% / var(--tw-text-opacity, 1)) !important;
}
.text-\\[hsl\\(30\\2c 9\\%\\2c 95\\%\\)\\]\\/70{
  color: hsl(30 9% 95% / 0.7) !important;
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground)) !important;
}
.text-amber{
  color: var(--amber) !important;
}
.text-approve{
  color: var(--approve) !important;
}
.text-background{
  color: hsl(var(--background)) !important;
}
.text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-400{
  --tw-text-opacity: 1 !important;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1)) !important;
}
.text-card-foreground{
  color: hsl(var(--card-foreground)) !important;
}
.text-current{
  color: currentColor !important;
}
.text-decline{
  color: var(--decline) !important;
}
.text-destructive{
  color: hsl(var(--destructive)) !important;
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground)) !important;
}
.text-foreground{
  color: hsl(var(--foreground)) !important;
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5) !important;
}
.text-foreground\\/60{
  color: hsl(var(--foreground) / 0.6) !important;
}
.text-foreground\\/70{
  color: hsl(var(--foreground) / 0.7) !important;
}
.text-foreground\\/75{
  color: hsl(var(--foreground) / 0.75) !important;
}
.text-foreground\\/80{
  color: hsl(var(--foreground) / 0.8) !important;
}
.text-foreground\\/85{
  color: hsl(var(--foreground) / 0.85) !important;
}
.text-foreground\\/90{
  color: hsl(var(--foreground) / 0.9) !important;
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground)) !important;
}
.text-muted-foreground\\/60{
  color: hsl(var(--muted-foreground) / 0.6) !important;
}
.text-muted-foreground\\/70{
  color: hsl(var(--muted-foreground) / 0.7) !important;
}
.text-neutral-inactive{
  color: var(--neutral-inactive) !important;
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground)) !important;
}
.text-primary{
  color: hsl(var(--primary)) !important;
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground)) !important;
}
.text-red-300{
  --tw-text-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}
.text-red-500{
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground)) !important;
}
.text-success{
  color: hsl(var(--success)) !important;
}
.text-warning{
  color: hsl(var(--warning)) !important;
}
.text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.underline{
  text-decoration-line: underline !important;
}
.line-through{
  text-decoration-line: line-through !important;
}
.decoration-border{
  text-decoration-color: hsl(var(--border)) !important;
}
.decoration-muted-foreground\\/60{
  text-decoration-color: hsl(var(--muted-foreground) / 0.6) !important;
}
.decoration-dotted{
  text-decoration-style: dotted !important;
}
.underline-offset-2{
  text-underline-offset: 2px !important;
}
.underline-offset-4{
  text-underline-offset: 4px !important;
}
.accent-\\[var\\(--primary\\)\\]{
  accent-color: var(--primary) !important;
}
.accent-primary{
  accent-color: hsl(var(--primary)) !important;
}
.opacity-0{
  opacity: 0 !important;
}
.opacity-100{
  opacity: 1 !important;
}
.opacity-40{
  opacity: 0.4 !important;
}
.opacity-50{
  opacity: 0.5 !important;
}
.opacity-55{
  opacity: 0.55 !important;
}
.opacity-60{
  opacity: 0.6 !important;
}
.opacity-70{
  opacity: 0.7 !important;
}
.opacity-80{
  opacity: 0.8 !important;
}
.opacity-90{
  opacity: 0.9 !important;
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline{
  outline-style: solid !important;
}
.outline-1{
  outline-width: 1px !important;
}
.outline-primary{
  outline-color: hsl(var(--primary)) !important;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-background{
  --tw-ring-color: hsl(var(--background)) !important;
}
.ring-primary{
  --tw-ring-color: hsl(var(--primary)) !important;
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring)) !important;
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background)) !important;
}
.grayscale{
  --tw-grayscale: grayscale(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.invert{
  --tw-invert: invert(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.sepia{
  --tw-sepia: sepia(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-saturate-150{
  --tw-backdrop-saturate: saturate(1.5) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all{
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-opacity{
  transition-property: opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-transform{
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-1000{
  transition-duration: 1000ms !important;
}
.duration-150{
  transition-duration: 150ms !important;
}
.duration-200{
  transition-duration: 200ms !important;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
@keyframes enter{
  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{
  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter !important;
  animation-duration: 150ms !important;
  --tw-enter-opacity: initial !important;
  --tw-enter-scale: initial !important;
  --tw-enter-rotate: initial !important;
  --tw-enter-translate-x: initial !important;
  --tw-enter-translate-y: initial !important;
}
.fade-in-0{
  --tw-enter-opacity: 0 !important;
}
.fade-in-80{
  --tw-enter-opacity: 0.8 !important;
}
.zoom-in-95{
  --tw-enter-scale: .95 !important;
}
.duration-1000{
  animation-duration: 1000ms !important;
}
.duration-150{
  animation-duration: 150ms !important;
}
.duration-200{
  animation-duration: 200ms !important;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.running{
  animation-play-state: running !important;
}
.\\[color-scheme\\:dark\\]{
  color-scheme: dark !important;
}
.\\[grid-template-rows\\:subgrid\\]{
  grid-template-rows: subgrid !important;
}

/* iframe#webpack-dev-server-client-overlay {display: none;} */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body > iframe {
  display: none !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* variables - start */
:root {
  --leftNavWidth: 90px;
  --colorYellow: #fd9f29;
  --colorWhite: #f4f3f2;
  --colorGray: #979a9f;
  --colorDGray: #323232;
  --colorGreen: #1a900a;
  --colorOrange: #e46c0a;
  --colorDOrange: #914507;
}
/* variables - end */

/* common - start */
body {
  font-family: "SegoeProDisplay-Regular", sans-serif;
  font-size: 14px;
  background-color: #0c1017;
  color: #f4f3f2;
  position: relative;
}
b {
  font-family: "SegoePro-Bold", sans-serif;
  font-weight: normal;
}
#loading {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  left: 0;
  top: 0;
}
#loading img {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -35px;
  margin-top: -35px;
}
.main-wrapper {
  margin-left: 90px; /* Fixed margin - always account for expanded sidebar width */
}
main {
  padding: 0px 35px 40px;
  margin-right: var(--rightNavWidth);
}
button {
  padding: 0;
  border: none;
  background-color: transparent;
}
button.btn {
  border: 1px solid var(--colorYellow);
}
a {
  text-decoration: none;
}
img {
  max-width: 100%;
}
.company-logo-img {
  display: inline-flex !important;
  height: 40px !important;
}
.full-ht {
  height: 100%;
}
button.btn-yellow,
button.btn-transparent,
a.btn-yellow,
a.btn-transparent {
  border: none;
  font-family: "SegoePro-Bold", sans-serif;
  font-size: 16px;
  padding: 10px 30px;
}
button.btn-yellow,
a.btn-yellow,
button.btn.btn-yellow:active,
button.btn.btn-yellow:hover,
button.btn.btn-yellow:focus-visible,
button.btn.btn-yellow:disabled {
  background-color: #fd9f29;
  color: #0c1017;
  border: 1px solid #fd9f29;
}
button.btn.btn-yellow:disabled,
a.btn-yellow:disabled {
  color: rgba(0, 0, 0, 0.4);
}
button.btn-transparent,
a.btn-transparent,
button.btn.btn-transparent:active,
button.btn-transparent:focus,
button.btn-transparent:hover,
button.btn-transparent:focus-visible {
  background-color: transparent;
  color: #fd9f29;
  border: 1px solid #fd9f29;
}
button.btn-small {
  padding: 0 5px;
  border-radius: 5px;
  font-size: 12px;
  height: 22px;
}
button.btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center
    center;
}
button.btn-transparent-gray,
button.btn-transparent-gray:hover {
  border-color: var(--colorGray);
  color: var(--colorGray);
}
.txt-small {
  font-size: 12px;
}
.txt-red {
  color: #ff0000;
}
.txt-white {
  color: var(--colorWhite);
}
.txt-yellow {
  color: var(--colorYellow);
}
.txt-orange {
  color: var(--colorOrange);
}
.txt-gray {
  color: var(--colorGray);
}
.align-end {
  display: inline-flex;
  height: 100%;
  align-items: flex-end;
}
.bdr-right {
  border-right: 1px solid var(--colorGray);
}
.border-dgray {
  border-color: var(--colorDGray) !important;
}
.chkbox-round {
  width: 25px;
  height: 25px;
  padding: 0;
  position: relative;
  min-height: auto;
}
.chkbox-round.form-check .form-check-input {
  visibility: hidden;
}
.chkbox-round.form-check .form-check-input,
.chkbox-round.form-check label {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  min-width: 25px;
  margin: 0;
  line-height: 25px;
}
.chkbox-round.form-check label {
  border: 1px solid var(--colorYellow);
  border-radius: 50%;
  cursor: pointer;
  text-align: center;
}
.chkbox-round.chkbox-orange.form-check label {
  border-color: var(--colorOrange);
}
.chkbox-round.chkbox-dorange.form-check label {
  border-color: var(--colorDOrange);
}
.chkbox-round.form-check .form-check-input:checked + label {
  background-color: var(--colorYellow);
  color: #000000;
  font-weight: bold;
}
.chkbox-round.chkbox-orange.form-check .form-check-input:checked + label {
  background-color: var(--colorOrange);
}
.chkbox-round.chkbox-dorange.form-check .form-check-input:checked + label {
  background-color: var(--colorDOrange);
}

.dropdown {
  padding-right: 30px;
  max-width: 100%;
}
.dropdown:after {
  content: "";
  position: absolute;
  display: block;
  width: 10px;
  height: 10px;
  border-top: 1px solid #bfbfbf;
  border-left: 1px solid #bfbfbf;
  transform: rotate(-135deg);
  right: 10px;
  top: 50%;
  margin-top: -8px;
}
.dropdown + .dropdown-list {
  width: 250px;
  max-width: 100%;
  position: absolute;
  z-index: 1;
}
.dropdown-list,
.sub-dropdown-list {
  display: none;
  background-color: #0c1017;
  list-style: none outside;
  padding: 10px 20px;
}
/* .dropdown-list input[type="checkbox"], .sub-dropdown-list input[type="checkbox"]{margin-right: 10px;} */
.dropdown + .dropdown-list > li > .sub-dropdown-list {
  position: absolute;
  width: 100%;
  left: calc(100% + 5px);
  top: 0;
  height: 300px;
  overflow-y: auto;
}
.dropdown.nested + .dropdown-list {
  position: relative;
}
.dropdown.simple + .dropdown-list {
  max-height: 200px;
  overflow-y: auto;
}

.divider {
  display: flex;
  align-items: center;
}
.divider:before,
.divider:after {
  flex: 1 1;
  content: "";
  height: 1px;
  background-color: #212121;
  margin: 5px;
}

/* scrollbar */
/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 4px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #444;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #777;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/* common - end */

/* leftnav - start */
.leftnav {
  background-color: #191e27;
  position: fixed;
  left: 0;
  top: 0;
  width: var(--leftNavWidth);
  height: 100%;
  text-align: center;
  padding: 25px 5px;
  max-height: 100vh;
  overflow-y: auto;
  z-index: 1000;
}
.leftnav .leftnav-logo {
  margin-bottom: 50px;
}
.leftnav ul {
  list-style: none outside;
  padding-left: 0;
}
.leftnav ul li:not(:last-child) {
  margin-bottom: 25px;
}
.leftnav ul li a {
  color: inherit;
  font-size: 11px;
  line-height: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.leftnav ul li a:hover img,
.leftnav ul li a.active img {
  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)
    hue-rotate(347deg) brightness(96%) contrast(107%);
}
.leftnav ul li a i {
  display: block;
  margin-bottom: 5px;
  transition: color 0.2s ease, filter 0.2s ease;
}
.leftnav ul li a:hover i,
.leftnav ul li a.active i {
  color: var(--colorYellow) !important;
  filter: grayscale(0%) !important;
}

/* Header icons hover effect */
header .header-right a[title="Support"]:hover img,
header .header-right a[title="Agora"]:hover img,
header .header-right a[title="Atlas"]:hover img {
  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)
    hue-rotate(347deg) brightness(96%) contrast(107%);
}
.leftnav ul li a span {
  display: block;
  margin-top: 5px;
  min-height: 1em;
  white-space: nowrap;
}
/* collapsed leftnav styles */
body.leftnav-collapsed {
  --leftNavWidth: 60px;
}
body.leftnav-collapsed .leftnav {
  width: var(--leftNavWidth);
  transition: width 0.3s ease;
}
body.leftnav-collapsed .leftnav ul li a span {
  visibility: hidden;
  opacity: 0;
  /* Keep in flow to reserve space */
  display: block;
  height: 1em;
  overflow: hidden;
}

/* Hover expansion - when collapsed sidebar is hovered, temporarily expand */
body.leftnav-collapsed.leftnav-hover-expanded {
  --leftNavWidth: 90px;
}
body.leftnav-collapsed.leftnav-hover-expanded .leftnav {
  width: var(--leftNavWidth);
  transition: width 0.3s ease;
}
body.leftnav-collapsed.leftnav-hover-expanded .leftnav ul li a span {
  visibility: visible;
  opacity: 1;
  display: block;
  height: auto;
  overflow: visible;
}
.leftnav .collapse-toggle {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 70px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transform: rotate(180deg);
}
.leftnav .collapse-toggle img {
  transition: transform 0.2s ease;
  transform: rotate(0deg);
}
body.leftnav-collapsed .leftnav .collapse-toggle img {
  transform: rotate(180deg);
}
/* leftnav - end */

/* header - start */
header {
  padding: 35px;
  margin-bottom: 20px;
  margin-right: var(--rightNavWidth);
}
header h1,
header h2 {
  font-family: "SegoePro-SemiBold", sans-serif;
  font-size: 18px;
  color: var(--colorYellow);
}
header h2 {
  margin-left: 8vw;
}
header .header-left {
  display: flex;
}
header .header-left .company-name:after {
  content: "|";
  margin: 0 10px;
  color: var(--colorGray);
}
header .header-right {
  margin-left: auto;
  display: flex;
  align-items: center;
}

header .header-right .toggle-page .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  min-width: auto;
  height: 20px;
  margin: 0 10px;
}
header .header-right .toggle-page .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
header .header-right .toggle-page .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2c2d2f;
  border: 1px solid var(--colorYellow);
  border-radius: 20px;
  transition: 0.4s;
}
header .header-right .toggle-page .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 1px;
  bottom: 1px;
  background-color: var(--colorYellow);
  border-radius: 50%;
  transition: 0.4s;
}
header .header-right .toggle-page input:checked + .slider:before {
  transform: translateX(20px);
}

header .header-right .notification {
  margin-left: 35px;
  position: relative;
}
header .header-right .notification button {
  position: relative;
}
header .header-right .notification button .count {
  display: none;
}
header .header-right .notification button.notification-true .count {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: red;
  right: 0;
  top: 2px;
  color: var(--colorWhite);
  font-size: 9px;
  line-height: 13px;
  display: block;
  text-align: center;
}
header .header-right .notification .notification-list {
  display: none;
  visibility: hidden;
  position: absolute;
  width: 210px;
  right: -20px;
  top: 100%;
  margin-top: 5px;
  background-color: #191e27;
  list-style: none outside;
  margin-bottom: 0;
  padding: 0 10px;
  font-size: 12px;
  color: var(--colorGray);
  box-shadow: 0px 3px 6px #00000029;
  z-index: 9;
}
header
  .header-right
  .notification
  button.notification-true
  + .notification-list {
  visibility: visible;
}
header
  .header-right
  .notification
  button.notification-true
  + .notification-list.show {
  display: block;
}
header .header-right .notification .notification-list li {
  padding: 10px 5px 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: right;
}
header .header-right .notification .notification-list li a {
  color: var(--colorYellow);
  margin-left: auto;
}
header .header-right .notification .notification-list li:not(:last-child) {
  border-bottom: 1px solid #3d4045;
}
header .header-right .notification .notification-list li:before {
  content: "\\2713 ";
  font-size: 9px;
  line-height: 15px;
  color: var(--colorYellow);
  min-width: 15px;
  height: 15px;
  background-color: #3d4045;
  border-radius: 50%;
  text-align: center;
  margin-right: 15px;
}

header .header-right .user {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid var(--colorYellow);
  position: relative;
}
header .header-right .user button {
  position: relative;
}
header .header-right .user .user-list {
  display: none;
  visibility: hidden;
  position: absolute;
  width: 100px;
  right: -37px;
  top: 100%;
  margin-top: 5px;
  background-color: #191e27;
  list-style: none outside;
  margin-bottom: 0;
  padding: 0 10px;
  font-size: 12px;
  color: var(--colorGray);
  box-shadow: 0px 3px 6px #00000029;
  z-index: 9;
}
header .header-right .user button.user-true + .user-list {
  visibility: visible;
}
header .header-right .user button.user-true + .user-list.show {
  display: block;
}
header .header-right .user .user-list li {
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
header .header-right .user .user-list li a {
  color: var(--colorGray);
  margin-left: 0;
}
header .header-right .user .user-list li a:hover {
  color: var(--colorYellow);
}
header .header-right .user .user-list li span {
  cursor: pointer;
  color: var(--colorGray);
}
header .header-right .user .user-list li span:hover {
  color: var(--colorYellow);
}
header .header-right .user .user-list li:not(:last-child) {
  border-bottom: 1px solid #3d4045;
}
/* header - end */

/*modal styles*/
.modal-content {
  padding: 3em; /* font-size:.8em; */
  background: rgba(25, 30, 39, 1);
  color: #f4f3f2;
  border: 1px solid #3d4045;
  border-radius: 0; /* Athena design language uses sharp edges, not curves */
}
.modal-content .form-text {
  font-size: 10px;
  color: #6c6f74;
}
.modal-content .requestdemo {
  margin-top: -35px;
}
/* .modal-content .form-check input{background:transparent;border:1px solid #979A9F;} */
/* .modal-content  */
.form-check label {
  color: #979a9f;
  transition: top 2s;
}
.modal-content .formitem {
  position: relative;
}
.modal-content .formitem .form-label {
  position: absolute;
  transition-duration: 1s;
}
.modal-content .formitem .form-label.raisedlabel {
  top: -25px;
}
.modal-footer button,
.modal-footer button:active,
.modal-footer button:focus {
  padding-left: 20px;
  padding-right: 20px;
}
.modal-footer button:active:hover,
.modal-footer button:hover {
  opacity: 0.8;
}
.modal-header {
  border: none;
  border-bottom: 1px solid rgba(151, 154, 159, 0.25);
  padding-bottom: 1.25em;
  margin-bottom: 0.75em;
}
.modal-title {
  color: #fd9f29;
  font-size: 1.35em;
  font-weight: 600;
}
.modal-footer {
  border: none;
  border-top: 1px solid rgba(151, 154, 159, 0.25);
  justify-content: flex-start;
  padding-top: 1.25em;
  margin-top: 0.75em;
}
.modal-content .message {
  font-size: 1.1em;
  color: #fd9f29;
}
/* Form fields inside modals — dark surface + amber focus border, matching the
   field styling used in UnderwritingEngineV2/portfolio-risk-concentration. */
.modal-content input[type="text"],
.modal-content input[type="email"],
.modal-content input[type="password"],
.modal-content input[type="tel"],
.modal-content input[type="number"],
.modal-content textarea,
.modal-content select,
.modal-content .form-select,
.modal-content .form-control {
  background-color: #12151b !important;
  border: 1px solid #3d4045 !important;
  color: #f4f3f2 !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
/* Consistent control height across every modal, so an inline "Add" button
   next to a dropdown/input lines up instead of towering over it. */
.modal-content select,
.modal-content .form-select,
.modal-content input[type="text"],
.modal-content input[type="email"],
.modal-content input[type="password"],
.modal-content input[type="tel"],
.modal-content input[type="number"],
.modal-content .form-control:not(textarea) {
  height: 38px;
}
.modal-content input[type="text"]::placeholder,
.modal-content input[type="email"]::placeholder,
.modal-content input[type="password"]::placeholder,
.modal-content input[type="tel"]::placeholder,
.modal-content input[type="number"]::placeholder,
.modal-content textarea::placeholder {
  color: #6c6f74;
}
.modal-content input[type="text"]:focus,
.modal-content input[type="email"]:focus,
.modal-content input[type="password"]:focus,
.modal-content input[type="tel"]:focus,
.modal-content input[type="number"]:focus,
.modal-content textarea:focus,
.modal-content select:focus,
.modal-content .form-select:focus,
.modal-content .form-control:focus,
.modal-content input:focus-visible,
.modal-content select:focus-visible,
.modal-content textarea:focus-visible {
  border-color: #fd9f29 !important;
  box-shadow: none !important;
  outline: none !important;
}
/* Bootstrap paints red/green borders on required/validated fields
   independent of focus — flatten those back to our own border color so
   an empty "required" dropdown doesn't show up red/off-brand. */
.modal-content input:invalid,
.modal-content input:valid,
.modal-content select:invalid,
.modal-content select:valid,
.modal-content textarea:invalid,
.modal-content textarea:valid,
.modal-content .form-control.is-invalid,
.modal-content .form-control.is-valid,
.modal-content .form-select.is-invalid,
.modal-content .form-select.is-valid {
  border-color: #3d4045 !important;
  box-shadow: none !important;
}
/* Native checkbox/radio "accent" color otherwise follows the browser/OS
   theme (can render as blue, green, or other off-brand colors). */
.modal-content input[type="checkbox"],
.modal-content input[type="radio"] {
  accent-color: #fd9f29;
}
/* Chrome/Edge autofill paints its own yellow background + text color;
   force it back to the dark field styling used everywhere else. */
.modal-content input:-webkit-autofill,
.modal-content input:-webkit-autofill:hover,
.modal-content input:-webkit-autofill:focus {
  -webkit-text-fill-color: #f4f3f2;
  box-shadow: 0 0 0px 1000px #12151b inset;
  caret-color: #f4f3f2;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
.modal-content select,
.modal-content .form-select {
  appearance: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 0.85rem center !important;
  background-size: 12px 8px !important;
  padding-right: 2.25rem !important;
}
/* Inline "Add" button used next to a role/tier picker — height-matched to
   the 38px control it sits beside, and vertically centered rather than
   inheriting the app-wide .btn-transparent's larger default padding. */
.modal-add-btn {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px !important;
  margin: 0 !important;
  white-space: nowrap;
}
.modal-content button[type="cancel"] {
  background: transparent;
  border: 1px solid #fd9f29;
  color: #fd9f29;
}
.btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-size: cover;
  position: relative;
  z-index: 1;
}
/* Small uppercase amber section label — the "eyebrow" pattern used throughout
   UnderwritingEngineV2 (e.g. "Admin · Eligibility" above "Guardrails Controller"). */
.modal-eyebrow {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #fd9f29;
}
/* Removable role/item chip — replaces the plain gray Bootstrap badge so
   assigned-role chips match the dark, sharp-edged Athena look. */
.modal-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  background-color: #191e27;
  border: 1px solid #3d4045;
  color: #f4f3f2;
  border-radius: 0;
  padding: 0.35em 0.6em;
  font-size: 0.8em;
  font-weight: 500;
}
.modal-chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5em;
  min-height: 1.5em;
  margin: -0.2em -0.3em -0.2em 0;
  font-size: 1.15em;
  line-height: 1;
  color: #979a9f;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.modal-chip-remove:hover,
.modal-chip-remove:focus-visible {
  color: #ffffff;
  background-color: #d9364a;
}
/*modal styles*/

/* Sharp corners on the app's primary/outline buttons, matching the
   Athena "edges, not curves" design language used across the newer modules. */
button.btn-yellow,
button.btn-transparent,
a.btn-yellow,
a.btn-transparent {
  border-radius: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* Header icon hover styles */
.header-icon-link {
  transition: color 0.2s ease, filter 0.2s ease;
  cursor: pointer;
}

.header-icon-link:hover {
  color: var(--colorYellow) !important;
  filter: grayscale(0%) !important;
}

.file\\:border-0::file-selector-button{
  border-width: 0px !important;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent !important;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500 !important;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground)) !important;
}

.placeholder\\:text-\\[hsl\\(0\\2c 0\\%\\2c 45\\%\\)\\]::placeholder{
  --tw-text-opacity: 1 !important;
  color: hsl(0 0% 45% / var(--tw-text-opacity, 1)) !important;
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground)) !important;
}

.placeholder\\:text-muted-foreground\\/60::placeholder{
  color: hsl(var(--muted-foreground) / 0.6) !important;
}

.after\\:absolute::after{
  content: var(--tw-content) !important;
  position: absolute !important;
}

.after\\:inset-y-0::after{
  content: var(--tw-content) !important;
  top: 0px !important;
  bottom: 0px !important;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content) !important;
  left: 50% !important;
}

.after\\:w-1::after{
  content: var(--tw-content) !important;
  width: 0.25rem !important;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content) !important;
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.first\\:border-l:first-child{
  border-left-width: 1px !important;
}

.first\\:border-t-0:first-child{
  border-top-width: 0px !important;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.last\\:border-0:last-child{
  border-width: 0px !important;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px !important;
}

.last\\:border-r-0:last-child{
  border-right-width: 0px !important;
}

.focus-within\\:relative:focus-within{
  position: relative !important;
}

.focus-within\\:z-20:focus-within{
  z-index: 20 !important;
}

.hover\\:border-amber:hover{
  border-color: var(--amber) !important;
}

.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-destructive:hover{
  border-color: hsl(var(--destructive)) !important;
}

.hover\\:border-foreground:hover{
  border-color: hsl(var(--foreground)) !important;
}

.hover\\:border-primary:hover{
  border-color: hsl(var(--primary)) !important;
}

.hover\\:border-primary\\/40:hover{
  border-color: hsl(var(--primary) / 0.4) !important;
}

.hover\\:border-primary\\/50:hover{
  border-color: hsl(var(--primary) / 0.5) !important;
}

.hover\\:border-primary\\/60:hover{
  border-color: hsl(var(--primary) / 0.6) !important;
}

.hover\\:border-secondary-foreground\\/60:hover{
  border-color: hsl(var(--secondary-foreground) / 0.6) !important;
}

.hover\\:border-success:hover{
  border-color: hsl(var(--success)) !important;
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent)) !important;
}

.hover\\:bg-accent\\/80:hover{
  background-color: hsl(var(--accent) / 0.8) !important;
}

.hover\\:bg-amber:hover{
  background-color: var(--amber) !important;
}

.hover\\:bg-amber-dim:hover{
  background-color: var(--amber-dim) !important;
}

.hover\\:bg-blue-400:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive)) !important;
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8) !important;
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9) !important;
}

.hover\\:bg-foreground:hover{
  background-color: hsl(var(--foreground)) !important;
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted)) !important;
}

.hover\\:bg-muted\\/20:hover{
  background-color: hsl(var(--muted) / 0.2) !important;
}

.hover\\:bg-muted\\/30:hover{
  background-color: hsl(var(--muted) / 0.3) !important;
}

.hover\\:bg-muted\\/40:hover{
  background-color: hsl(var(--muted) / 0.4) !important;
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5) !important;
}

.hover\\:bg-muted\\/60:hover{
  background-color: hsl(var(--muted) / 0.6) !important;
}

.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary)) !important;
}

.hover\\:bg-primary\\/20:hover{
  background-color: hsl(var(--primary) / 0.2) !important;
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8) !important;
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9) !important;
}

.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary)) !important;
}

.hover\\:bg-secondary\\/40:hover{
  background-color: hsl(var(--secondary) / 0.4) !important;
}

.hover\\:bg-secondary\\/50:hover{
  background-color: hsl(var(--secondary) / 0.5) !important;
}

.hover\\:bg-secondary\\/60:hover{
  background-color: hsl(var(--secondary) / 0.6) !important;
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8) !important;
}

.hover\\:bg-success:hover{
  background-color: hsl(var(--success)) !important;
}

.hover\\:bg-transparent:hover{
  background-color: transparent !important;
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground)) !important;
}

.hover\\:text-amber:hover{
  color: var(--amber) !important;
}

.hover\\:text-background:hover{
  color: hsl(var(--background)) !important;
}

.hover\\:text-destructive:hover{
  color: hsl(var(--destructive)) !important;
}

.hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground)) !important;
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground)) !important;
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground)) !important;
}

.hover\\:text-primary:hover{
  color: hsl(var(--primary)) !important;
}

.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground)) !important;
}

.hover\\:text-secondary-foreground:hover{
  color: hsl(var(--secondary-foreground)) !important;
}

.hover\\:text-success-foreground:hover{
  color: hsl(var(--success-foreground)) !important;
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:underline:hover{
  text-decoration-line: underline !important;
}

.hover\\:no-underline:hover{
  text-decoration-line: none !important;
}

.hover\\:opacity-100:hover{
  opacity: 1 !important;
}

.hover\\:opacity-80:hover{
  opacity: 0.8 !important;
}

.hover\\:ring-1:hover{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:border-amber:focus{
  border-color: var(--amber) !important;
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent)) !important;
}

.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary)) !important;
}

.focus\\:bg-secondary\\/40:focus{
  background-color: hsl(var(--secondary) / 0.4) !important;
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground)) !important;
}

.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground)) !important;
}

.focus\\:opacity-100:focus{
  opacity: 1 !important;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-primary:focus{
  --tw-ring-color: hsl(var(--primary)) !important;
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring)) !important;
}

.focus\\:ring-white\\/40:focus{
  --tw-ring-color: rgb(255 255 255 / 0.4) !important;
}

.focus\\:ring-offset-0:focus{
  --tw-ring-offset-width: 0px !important;
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px !important;
}

.focus\\:ring-offset-background:focus{
  --tw-ring-offset-color: hsl(var(--background)) !important;
}

.focus-visible\\:border-amber:focus-visible{
  border-color: var(--amber) !important;
}

.focus-visible\\:text-amber:focus-visible{
  color: var(--amber) !important;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-primary:focus-visible{
  --tw-ring-color: hsl(var(--primary)) !important;
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring)) !important;
}

.focus-visible\\:ring-offset-0:focus-visible{
  --tw-ring-offset-width: 0px !important;
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px !important;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px !important;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background)) !important;
}

.active\\:cursor-grabbing:active{
  cursor: grabbing !important;
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none !important;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed !important;
}

.disabled\\:bg-amber-dim:disabled{
  background-color: var(--amber-dim) !important;
}

.disabled\\:text-muted-foreground:disabled{
  color: hsl(var(--muted-foreground)) !important;
}

.disabled\\:opacity-100:disabled{
  opacity: 1 !important;
}

.disabled\\:opacity-25:disabled{
  opacity: 0.25 !important;
}

.disabled\\:opacity-30:disabled{
  opacity: 0.3 !important;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4 !important;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5 !important;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1 !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary)) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground)) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground)) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626 !important;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed !important;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7 !important;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5 !important;
}

.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent)) !important;
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5) !important;
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground)) !important;
}

.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground)) !important;
}

.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1 !important;
}

.aria-selected\\:opacity-30[aria-selected="true"]{
  opacity: 0.3 !important;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none !important;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100% !important;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"]{
  --tw-translate-x: 1.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

@keyframes accordion-up{
  from{
    height: var(--radix-accordion-content-height);
  }
  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out !important;
}

@keyframes accordion-down{
  from{
    height: 0;
  }
  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column !important;
}

.data-\\[active\\]\\:bg-accent\\/50[data-active]{
  background-color: hsl(var(--accent) / 0.5) !important;
}

.data-\\[selected\\=\\'true\\'\\]\\:bg-accent[data-selected='true']{
  background-color: hsl(var(--accent)) !important;
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background)) !important;
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary)) !important;
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent)) !important;
}

.data-\\[state\\=on\\]\\:bg-primary[data-state="on"]{
  background-color: hsl(var(--primary)) !important;
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent)) !important;
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5) !important;
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary)) !important;
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted)) !important;
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input)) !important;
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground)) !important;
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground)) !important;
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground)) !important;
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground)) !important;
}

.data-\\[state\\=on\\]\\:text-primary-foreground[data-state="on"]{
  color: hsl(var(--primary-foreground)) !important;
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground)) !important;
}

.data-\\[state\\=open\\]\\:text-white[data-state="open"]{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5 !important;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5 !important;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"]{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none !important;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms !important;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms !important;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter !important;
  animation-duration: 150ms !important;
  --tw-enter-opacity: initial !important;
  --tw-enter-scale: initial !important;
  --tw-enter-rotate: initial !important;
  --tw-enter-translate-x: initial !important;
  --tw-enter-translate-y: initial !important;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter !important;
  animation-duration: 150ms !important;
  --tw-enter-opacity: initial !important;
  --tw-enter-scale: initial !important;
  --tw-enter-rotate: initial !important;
  --tw-enter-translate-x: initial !important;
  --tw-enter-translate-y: initial !important;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter !important;
  animation-duration: 150ms !important;
  --tw-enter-opacity: initial !important;
  --tw-enter-scale: initial !important;
  --tw-enter-rotate: initial !important;
  --tw-enter-translate-x: initial !important;
  --tw-enter-translate-y: initial !important;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit !important;
  animation-duration: 150ms !important;
  --tw-exit-opacity: initial !important;
  --tw-exit-scale: initial !important;
  --tw-exit-rotate: initial !important;
  --tw-exit-translate-x: initial !important;
  --tw-exit-translate-y: initial !important;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit !important;
  animation-duration: 150ms !important;
  --tw-exit-opacity: initial !important;
  --tw-exit-scale: initial !important;
  --tw-exit-rotate: initial !important;
  --tw-exit-translate-x: initial !important;
  --tw-exit-translate-y: initial !important;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit !important;
  animation-duration: 150ms !important;
  --tw-exit-opacity: initial !important;
  --tw-exit-scale: initial !important;
  --tw-exit-rotate: initial !important;
  --tw-exit-translate-x: initial !important;
  --tw-exit-translate-y: initial !important;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit !important;
  animation-duration: 150ms !important;
  --tw-exit-opacity: initial !important;
  --tw-exit-scale: initial !important;
  --tw-exit-rotate: initial !important;
  --tw-exit-translate-x: initial !important;
  --tw-exit-translate-y: initial !important;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0 !important;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8 !important;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0 !important;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95 !important;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9 !important;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95 !important;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem !important;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem !important;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem !important;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem !important;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem !important;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem !important;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem !important;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100% !important;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms !important;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content) !important;
  left: 0px !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content) !important;
  height: 0.25rem !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content) !important;
  width: 100% !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content) !important;
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content) !important;
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=on\\]\\:hover\\:bg-primary:hover[data-state="on"]{
  background-color: hsl(var(--primary)) !important;
}

.data-\\[state\\=on\\]\\:hover\\:text-primary-foreground:hover[data-state="on"]{
  color: hsl(var(--primary-foreground)) !important;
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive)) !important;
}

@media (min-width: 640px){
  .sm\\:bottom-0{
    bottom: 0px !important;
  }
  .sm\\:right-0{
    right: 0px !important;
  }
  .sm\\:top-auto{
    top: auto !important;
  }
  .sm\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }
  .sm\\:mt-0{
    margin-top: 0px !important;
  }
  .sm\\:max-w-2xl{
    max-width: 42rem !important;
  }
  .sm\\:max-w-3xl{
    max-width: 48rem !important;
  }
  .sm\\:max-w-4xl{
    max-width: 56rem !important;
  }
  .sm\\:max-w-\\[520px\\]{
    max-width: 520px !important;
  }
  .sm\\:max-w-lg{
    max-width: 32rem !important;
  }
  .sm\\:max-w-md{
    max-width: 28rem !important;
  }
  .sm\\:max-w-sm{
    max-width: 24rem !important;
  }
  .sm\\:max-w-xl{
    max-width: 36rem !important;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
  .sm\\:grid-cols-\\[150px_1fr_auto_auto_auto\\]{
    grid-template-columns: 150px 1fr auto auto auto !important;
  }
  .sm\\:grid-cols-\\[150px_150px_1fr_auto\\]{
    grid-template-columns: 150px 150px 1fr auto !important;
  }
  .sm\\:grid-cols-\\[150px_1fr_auto\\]{
    grid-template-columns: 150px 1fr auto !important;
  }
  .sm\\:flex-row{
    flex-direction: row !important;
  }
  .sm\\:flex-col{
    flex-direction: column !important;
  }
  .sm\\:items-end{
    align-items: flex-end !important;
  }
  .sm\\:items-center{
    align-items: center !important;
  }
  .sm\\:justify-end{
    justify-content: flex-end !important;
  }
  .sm\\:justify-between{
    justify-content: space-between !important;
  }
  .sm\\:gap-2\\.5{
    gap: 0.625rem !important;
  }
  .sm\\:gap-3{
    gap: 0.75rem !important;
  }
  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
  }
  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
  }
  .sm\\:rounded-lg{
    border-radius: 0px !important;
  }
  .sm\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  .sm\\:text-left{
    text-align: left !important;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
  }
  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100% !important;
  }
}

@media (min-width: 768px){
  .md\\:absolute{
    position: absolute !important;
  }
  .md\\:col-span-1{
    grid-column: span 1 / span 1 !important;
  }
  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width) !important;
  }
  .md\\:w-auto{
    width: auto !important;
  }
  .md\\:max-w-\\[420px\\]{
    max-width: 420px !important;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .md\\:p-8{
    padding: 2rem !important;
  }
  .md\\:text-3xl{
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
  }
  .md\\:text-sm{
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }
}

@media (min-width: 1024px){
  .lg\\:sticky{
    position: sticky !important;
  }
  .lg\\:top-\\[200px\\]{
    top: 200px !important;
  }
  .lg\\:order-none{
    order: 0 !important;
  }
  .lg\\:col-span-3{
    grid-column: span 3 / span 3 !important;
  }
  .lg\\:col-span-5{
    grid-column: span 5 / span 5 !important;
  }
  .lg\\:inline{
    display: inline !important;
  }
  .lg\\:max-h-\\[calc\\(100vh-220px\\)\\]{
    max-height: calc(100vh - 220px) !important;
  }
  .lg\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr) !important;
  }
  .lg\\:grid-flow-col{
    grid-auto-flow: column !important;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 340px\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,340px) minmax(0,1fr) !important;
  }
  .lg\\:grid-cols-none{
    grid-template-columns: none !important;
  }
  .lg\\:self-start{
    align-self: flex-start !important;
  }
  .lg\\:overflow-y-auto{
    overflow-y: auto !important;
  }
}

@media (min-width: 1280px){
  .xl\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }
  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }
}

.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:invert::-webkit-calendar-picker-indicator{
  --tw-invert: invert(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent)) !important;
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5) !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px !important;
}

.\\[\\&\\>button\\:last-child\\]\\:text-white\\/70>button:last-child{
  color: rgb(255 255 255 / 0.7) !important;
}

.\\[\\&\\>button\\:last-child\\]\\:hover\\:text-white:hover>button:last-child{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&\\>button\\>svg\\]\\:h-5>button>svg{
  height: 1.25rem !important;
}

.\\[\\&\\>button\\>svg\\]\\:w-5>button>svg{
  width: 1.25rem !important;
}

.\\[\\&\\>button\\]\\:z-10>button{
  z-index: 10 !important;
}

.\\[\\&\\>button\\]\\:hidden>button{
  display: none !important;
}

.\\[\\&\\>button\\]\\:h-6>button{
  height: 1.5rem !important;
}

.\\[\\&\\>button\\]\\:w-6>button{
  width: 1.5rem !important;
}

.\\[\\&\\>button\\]\\:text-foreground\\/70>button{
  color: hsl(var(--foreground) / 0.7) !important;
}

.\\[\\&\\>button\\]\\:hover\\:text-foreground:hover>button{
  color: hsl(var(--foreground)) !important;
}

.\\[\\&\\>button_svg\\]\\:text-white>button svg{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&\\>div\\:last-child\\]\\:mt-3>div:last-child{
  margin-top: 0.75rem !important;
}

.\\[\\&\\>div\\]\\:hidden>div{
  display: none !important;
}

.\\[\\&\\>option\\]\\:bg-popover>option{
  background-color: hsl(var(--popover)) !important;
}

.\\[\\&\\>option\\]\\:text-foreground>option{
  color: hsl(var(--foreground)) !important;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 1 !important;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute !important;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem !important;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem !important;
}

.\\[\\&\\>svg\\]\\:hidden>svg{
  display: none !important;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg{
  width: 0.875rem !important;
  height: 0.875rem !important;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg{
  height: 0.625rem !important;
}

.\\[\\&\\>svg\\]\\:h-3>svg{
  height: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg{
  width: 0.625rem !important;
}

.\\[\\&\\>svg\\]\\:w-3>svg{
  width: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:\\!text-primary>svg{
  color: hsl(var(--primary)) !important;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive)) !important;
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground)) !important;
}

.\\[\\&\\>svg\\]\\:text-muted-foreground>svg{
  color: hsl(var(--muted-foreground)) !important;
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem !important;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px !important;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text{
  fill: hsl(var(--muted-foreground)) !important;
}

.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc']{
  stroke: hsl(var(--border) / 0.5) !important;
}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor{
  stroke: hsl(var(--border)) !important;
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff']{
  stroke: transparent !important;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc']{
  stroke: hsl(var(--border)) !important;
}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector{
  fill: hsl(var(--muted)) !important;
}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor{
  fill: hsl(var(--muted)) !important;
}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc']{
  stroke: hsl(var(--border)) !important;
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff']{
  stroke: transparent !important;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500 !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground)) !important;
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px !important;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem !important;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem !important;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem !important;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem !important;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:h-5 [role=slider]{
  height: 1.25rem !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:w-5 [role=slider]{
  width: 1.25rem !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:border-amber [role=slider]{
  border-color: var(--amber) !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:bg-amber [role=slider]{
  background-color: var(--amber) !important;
}

.\\[\\&_h2\\]\\:text-xs h2{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}

.\\[\\&_h2\\]\\:leading-snug h2{
  line-height: 1.375 !important;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625 !important;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none !important;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem !important;
  height: 1rem !important;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0 !important;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px !important;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,mDAAmD;AACnD;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,6BAAmB;EAAnB,qBAAmB;EAAnB,sBAAmB;EAAnB,qBAAmB;EAAnB,uBAAmB;EAAnB,2BAAmB;EAAnB,iCAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0FAAmB;EAAnB,8GAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,4GAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,+GAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mKAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,gCAAmB;EAAnB,oCAAmB;EAAnB,sCAAmB;EAAnB,oCAAmB;EAAnB,qCAAmB;EAAnB,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,8DAA8D;AAC9D;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;aACW;AACb;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;AACA,oBAAoB;;AAEpB,mBAAmB;AACnB;EACE,kDAAkD;EAClD,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,OAAO;EACP,MAAM;AACR;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB,EAAE,6DAA6D;AAClF;AACA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;;;;EAIE,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;EAME,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;;;EAME,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE;UACQ;AACV;AACA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA,0GAA0G;AAC1G;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA,cAAc;AACd,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;AACA,UAAU;AACV;EACE,gBAAgB;AAClB;AACA,WAAW;AACX;EACE,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA,iBAAiB;;AAEjB,oBAAoB;AACpB;EACE,yBAAyB;EACzB,eAAe;EACf,OAAO;EACP,MAAM;EACN,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE;qDACmD;AACrD;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;;;EAGE;qDACmD;AACrD;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA,6BAA6B;AAC7B;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA,kBAAkB;;AAElB,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;AACA;;EAEE,4CAA4C;EAC5C,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EAEnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,QAAQ;EACR,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,UAAU;AACZ;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA,iBAAiB;;AAEjB,eAAe;AACf;EACE,YAAY,EAAE,oBAAoB;EAClC,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;EACzB,gBAAgB,EAAE,wDAAwD;AAC5E;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA,uFAAuF;AACvF,oBAAoB;AACpB;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kDAAkD;EAClD,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,+CAA+C;EAC/C,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;6EAC6E;AAC7E;;;;;;;;;EASE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;mEACmE;AACnE;;;;;;;;EAQE,YAAY;AACd;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,gCAAgC;EAChC,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;;gEAEgE;AAChE;;;;;;;;;;EAUE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;kEACkE;AAClE;;EAEE,qBAAqB;AACvB;AACA;kEACkE;AAClE;;;EAGE,gCAAgC;EAEhC,wCAAwC;EACxC,oBAAoB;EACpB,yDAAiD;EAAjD,iDAAiD;AACnD;AACA;;EAIE,2BAA2B;EAC3B,oEAAsV;EACtV,uCAAuC;EACvC,oDAAoD;EACpD,oCAAoC;EACpC,iCAAiC;AACnC;AACA;;uEAEuE;AACvE;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,6DAAiE;EACjE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA;qFACqF;AACrF;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;iEACiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,yDAAyD;AAC3D;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA,eAAe;;AAEf;8EAC8E;AAC9E;;;;EAIE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AA72BA;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,8BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD,mBA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD,iCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,uCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,iCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,6BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA,sHA62BC;EA72BD,oHA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,0FA62BC;EA72BD,8GA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,oCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,oCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,oCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,gCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,gCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,2DA62BC;EA72BD;AA62BC;;AA72BD;EAAA,4DA62BC;EA72BD;AA62BC;;AA72BD;EAAA;IAAA;EA62BC;EA72BD;IAAA;EA62BC;AAAA;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;IAAA;EA62BC;EA72BD;IAAA;EA62BC;AAAA;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,qDA62BC;EA72BD,kEA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,gCA62BC;EA72BD,oCA62BC;EA72BD,sCA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,0CA62BC;EA72BD;AA62BC;;AA72BD;EAAA,gCA62BC;EA72BD,oCA62BC;EA72BD,sCA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,0CA62BC;EA72BD;AA62BC;;AA72BD;EAAA,gCA62BC;EA72BD,oCA62BC;EA72BD,sCA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,0CA62BC;EA72BD;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,mCA62BC;EA72BD,oCA62BC;EA72BD,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,mCA62BC;EA72BD,oCA62BC;EA72BD,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,mCA62BC;EA72BD,oCA62BC;EA72BD,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD,oCA62BC;EA72BD,qCA62BC;EA72BD,mCA62BC;EA72BD,oCA62BC;EA72BD,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD,iCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,qCA62BC;EA72BD,gCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,8BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA,kCA62BC;IA72BD,iEA62BC;IA72BD;EA62BC;EA72BD;IAAA,kCA62BC;IA72BD,+DA62BC;IA72BD;EA62BC;EA72BD;IAAA,kCA62BC;IA72BD,sEA62BC;IA72BD;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA,+BA62BC;IA72BD;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA,8BA62BC;IA72BD;EA62BC;EA72BD;IAAA;EA62BC;AAAA;;AA72BD;EAAA;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA,8BA62BC;IA72BD;EA62BC;EA72BD;IAAA,8BA62BC;IA72BD;EA62BC;AAAA;;AA72BD;EAAA;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;AAAA;;AA72BD;EAAA;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;EA72BD;IAAA;EA62BC;AAAA;;AA72BD;EAAA,oCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,sCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,uCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,uCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,2BA62BC;EA72BD,+BA62BC;EA72BD,uCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,iCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,0BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,6BA62BC;EA72BD;AA62BC;;AA72BD;EAAA,8BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,yCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA,gCA62BC;EA72BD;AA62BC;;AA72BD;EAAA,6BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA,+BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,6BA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA,sBA62BC;EA72BD;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC;;AA72BD;EAAA;AA62BC","sourcesContent":["@import \"./assets/fonts/fonts.css\";\n\n/* Tailwind CSS - Required for PromotionIQ module */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* iframe#webpack-dev-server-client-overlay {display: none;} */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody > iframe {\n  display: none !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* variables - start */\n:root {\n  --leftNavWidth: 90px;\n  --colorYellow: #fd9f29;\n  --colorWhite: #f4f3f2;\n  --colorGray: #979a9f;\n  --colorDGray: #323232;\n  --colorGreen: #1a900a;\n  --colorOrange: #e46c0a;\n  --colorDOrange: #914507;\n}\n/* variables - end */\n\n/* common - start */\nbody {\n  font-family: \"SegoeProDisplay-Regular\", sans-serif;\n  font-size: 14px;\n  background-color: #0c1017;\n  color: #f4f3f2;\n  position: relative;\n}\nb {\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-weight: normal;\n}\n#loading {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  left: 0;\n  top: 0;\n}\n#loading img {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-left: -35px;\n  margin-top: -35px;\n}\n.main-wrapper {\n  margin-left: 90px; /* Fixed margin - always account for expanded sidebar width */\n}\nmain {\n  padding: 0px 35px 40px;\n  margin-right: var(--rightNavWidth);\n}\nbutton {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\nbutton.btn {\n  border: 1px solid var(--colorYellow);\n}\na {\n  text-decoration: none;\n}\nimg {\n  max-width: 100%;\n}\n.company-logo-img {\n  display: inline-flex !important;\n  height: 40px !important;\n}\n.full-ht {\n  height: 100%;\n}\nbutton.btn-yellow,\nbutton.btn-transparent,\na.btn-yellow,\na.btn-transparent {\n  border: none;\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-size: 16px;\n  padding: 10px 30px;\n}\nbutton.btn-yellow,\na.btn-yellow,\nbutton.btn.btn-yellow:active,\nbutton.btn.btn-yellow:hover,\nbutton.btn.btn-yellow:focus-visible,\nbutton.btn.btn-yellow:disabled {\n  background-color: #fd9f29;\n  color: #0c1017;\n  border: 1px solid #fd9f29;\n}\nbutton.btn.btn-yellow:disabled,\na.btn-yellow:disabled {\n  color: rgba(0, 0, 0, 0.4);\n}\nbutton.btn-transparent,\na.btn-transparent,\nbutton.btn.btn-transparent:active,\nbutton.btn-transparent:focus,\nbutton.btn-transparent:hover,\nbutton.btn-transparent:focus-visible {\n  background-color: transparent;\n  color: #fd9f29;\n  border: 1px solid #fd9f29;\n}\nbutton.btn-small {\n  padding: 0 5px;\n  border-radius: 5px;\n  font-size: 12px;\n  height: 22px;\n}\nbutton.btn-close {\n  background: url(\"./assets/images/icons/close-icon.png\") no-repeat center\n    center;\n}\nbutton.btn-transparent-gray,\nbutton.btn-transparent-gray:hover {\n  border-color: var(--colorGray);\n  color: var(--colorGray);\n}\n.txt-small {\n  font-size: 12px;\n}\n.txt-red {\n  color: #ff0000;\n}\n.txt-white {\n  color: var(--colorWhite);\n}\n.txt-yellow {\n  color: var(--colorYellow);\n}\n.txt-orange {\n  color: var(--colorOrange);\n}\n.txt-gray {\n  color: var(--colorGray);\n}\n.align-end {\n  display: inline-flex;\n  height: 100%;\n  align-items: flex-end;\n}\n.bdr-right {\n  border-right: 1px solid var(--colorGray);\n}\n.border-dgray {\n  border-color: var(--colorDGray) !important;\n}\n.chkbox-round {\n  width: 25px;\n  height: 25px;\n  padding: 0;\n  position: relative;\n  min-height: auto;\n}\n.chkbox-round.form-check .form-check-input {\n  visibility: hidden;\n}\n.chkbox-round.form-check .form-check-input,\n.chkbox-round.form-check label {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  min-width: 25px;\n  margin: 0;\n  line-height: 25px;\n}\n.chkbox-round.form-check label {\n  border: 1px solid var(--colorYellow);\n  border-radius: 50%;\n  cursor: pointer;\n  text-align: center;\n}\n.chkbox-round.chkbox-orange.form-check label {\n  border-color: var(--colorOrange);\n}\n.chkbox-round.chkbox-dorange.form-check label {\n  border-color: var(--colorDOrange);\n}\n.chkbox-round.form-check .form-check-input:checked + label {\n  background-color: var(--colorYellow);\n  color: #000000;\n  font-weight: bold;\n}\n.chkbox-round.chkbox-orange.form-check .form-check-input:checked + label {\n  background-color: var(--colorOrange);\n}\n.chkbox-round.chkbox-dorange.form-check .form-check-input:checked + label {\n  background-color: var(--colorDOrange);\n}\n\n.dropdown {\n  padding-right: 30px;\n  max-width: 100%;\n}\n.dropdown:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-top: 1px solid #bfbfbf;\n  border-left: 1px solid #bfbfbf;\n  transform: rotate(-135deg);\n  right: 10px;\n  top: 50%;\n  margin-top: -8px;\n}\n.dropdown + .dropdown-list {\n  width: 250px;\n  max-width: 100%;\n  position: absolute;\n  z-index: 1;\n}\n.dropdown-list,\n.sub-dropdown-list {\n  display: none;\n  background-color: #0c1017;\n  list-style: none outside;\n  padding: 10px 20px;\n}\n/* .dropdown-list input[type=\"checkbox\"], .sub-dropdown-list input[type=\"checkbox\"]{margin-right: 10px;} */\n.dropdown + .dropdown-list > li > .sub-dropdown-list {\n  position: absolute;\n  width: 100%;\n  left: calc(100% + 5px);\n  top: 0;\n  height: 300px;\n  overflow-y: auto;\n}\n.dropdown.nested + .dropdown-list {\n  position: relative;\n}\n.dropdown.simple + .dropdown-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n}\n.divider:before,\n.divider:after {\n  flex: 1;\n  content: \"\";\n  height: 1px;\n  background-color: #212121;\n  margin: 5px;\n}\n\n/* scrollbar */\n/* width */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 4px;\n}\n/* Track */\n::-webkit-scrollbar-track {\n  background: #444;\n}\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #777;\n}\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n/* common - end */\n\n/* leftnav - start */\n.leftnav {\n  background-color: #191e27;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: var(--leftNavWidth);\n  height: 100%;\n  text-align: center;\n  padding: 25px 5px;\n  max-height: 100vh;\n  overflow-y: auto;\n  z-index: 1000;\n}\n.leftnav .leftnav-logo {\n  margin-bottom: 50px;\n}\n.leftnav ul {\n  list-style: none outside;\n  padding-left: 0;\n}\n.leftnav ul li:not(:last-child) {\n  margin-bottom: 25px;\n}\n.leftnav ul li a {\n  color: inherit;\n  font-size: 11px;\n  line-height: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.leftnav ul li a:hover img,\n.leftnav ul li a.active img {\n  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)\n    hue-rotate(347deg) brightness(96%) contrast(107%);\n}\n.leftnav ul li a i {\n  display: block;\n  margin-bottom: 5px;\n  transition: color 0.2s ease, filter 0.2s ease;\n}\n.leftnav ul li a:hover i,\n.leftnav ul li a.active i {\n  color: var(--colorYellow) !important;\n  filter: grayscale(0%) !important;\n}\n\n/* Header icons hover effect */\nheader .header-right a[title=\"Support\"]:hover img,\nheader .header-right a[title=\"Agora\"]:hover img,\nheader .header-right a[title=\"Atlas\"]:hover img {\n  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)\n    hue-rotate(347deg) brightness(96%) contrast(107%);\n}\n.leftnav ul li a span {\n  display: block;\n  margin-top: 5px;\n  min-height: 1em;\n  white-space: nowrap;\n}\n/* collapsed leftnav styles */\nbody.leftnav-collapsed {\n  --leftNavWidth: 60px;\n}\nbody.leftnav-collapsed .leftnav {\n  width: var(--leftNavWidth);\n  transition: width 0.3s ease;\n}\nbody.leftnav-collapsed .leftnav ul li a span {\n  visibility: hidden;\n  opacity: 0;\n  /* Keep in flow to reserve space */\n  display: block;\n  height: 1em;\n  overflow: hidden;\n}\n\n/* Hover expansion - when collapsed sidebar is hovered, temporarily expand */\nbody.leftnav-collapsed.leftnav-hover-expanded {\n  --leftNavWidth: 90px;\n}\nbody.leftnav-collapsed.leftnav-hover-expanded .leftnav {\n  width: var(--leftNavWidth);\n  transition: width 0.3s ease;\n}\nbody.leftnav-collapsed.leftnav-hover-expanded .leftnav ul li a span {\n  visibility: visible;\n  opacity: 1;\n  display: block;\n  height: auto;\n  overflow: visible;\n}\n.leftnav .collapse-toggle {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  bottom: 70px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transform: rotate(180deg);\n}\n.leftnav .collapse-toggle img {\n  transition: transform 0.2s ease;\n  transform: rotate(0deg);\n}\nbody.leftnav-collapsed .leftnav .collapse-toggle img {\n  transform: rotate(180deg);\n}\n/* leftnav - end */\n\n/* header - start */\nheader {\n  padding: 35px;\n  margin-bottom: 20px;\n  margin-right: var(--rightNavWidth);\n}\nheader h1,\nheader h2 {\n  font-family: \"SegoePro-SemiBold\", sans-serif;\n  font-size: 18px;\n  color: var(--colorYellow);\n}\nheader h2 {\n  margin-left: 8vw;\n}\nheader .header-left {\n  display: flex;\n}\nheader .header-left .company-name:after {\n  content: \"|\";\n  margin: 0 10px;\n  color: var(--colorGray);\n}\nheader .header-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\nheader .header-right .toggle-page .switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  min-width: auto;\n  height: 20px;\n  margin: 0 10px;\n}\nheader .header-right .toggle-page .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\nheader .header-right .toggle-page .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #2c2d2f;\n  border: 1px solid var(--colorYellow);\n  border-radius: 20px;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\nheader .header-right .toggle-page .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 1px;\n  bottom: 1px;\n  background-color: var(--colorYellow);\n  border-radius: 50%;\n  transition: 0.4s;\n}\nheader .header-right .toggle-page input:checked + .slider:before {\n  -webkit-transform: translateX(20px);\n  -ms-transform: translateX(20px);\n  transform: translateX(20px);\n}\n\nheader .header-right .notification {\n  margin-left: 35px;\n  position: relative;\n}\nheader .header-right .notification button {\n  position: relative;\n}\nheader .header-right .notification button .count {\n  display: none;\n}\nheader .header-right .notification button.notification-true .count {\n  position: absolute;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: red;\n  right: 0;\n  top: 2px;\n  color: var(--colorWhite);\n  font-size: 9px;\n  line-height: 13px;\n  display: block;\n  text-align: center;\n}\nheader .header-right .notification .notification-list {\n  display: none;\n  visibility: hidden;\n  position: absolute;\n  width: 210px;\n  right: -20px;\n  top: 100%;\n  margin-top: 5px;\n  background-color: #191e27;\n  list-style: none outside;\n  margin-bottom: 0;\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--colorGray);\n  box-shadow: 0px 3px 6px #00000029;\n  z-index: 9;\n}\nheader\n  .header-right\n  .notification\n  button.notification-true\n  + .notification-list {\n  visibility: visible;\n}\nheader\n  .header-right\n  .notification\n  button.notification-true\n  + .notification-list.show {\n  display: block;\n}\nheader .header-right .notification .notification-list li {\n  padding: 10px 5px 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: right;\n}\nheader .header-right .notification .notification-list li a {\n  color: var(--colorYellow);\n  margin-left: auto;\n}\nheader .header-right .notification .notification-list li:not(:last-child) {\n  border-bottom: 1px solid #3d4045;\n}\nheader .header-right .notification .notification-list li:before {\n  content: \"\\2713 \";\n  font-size: 9px;\n  line-height: 15px;\n  color: var(--colorYellow);\n  min-width: 15px;\n  height: 15px;\n  background-color: #3d4045;\n  border-radius: 50%;\n  text-align: center;\n  margin-right: 15px;\n}\n\nheader .header-right .user {\n  margin-left: 20px;\n  padding-left: 20px;\n  border-left: 1px solid var(--colorYellow);\n  position: relative;\n}\nheader .header-right .user button {\n  position: relative;\n}\nheader .header-right .user .user-list {\n  display: none;\n  visibility: hidden;\n  position: absolute;\n  width: 100px;\n  right: -37px;\n  top: 100%;\n  margin-top: 5px;\n  background-color: #191e27;\n  list-style: none outside;\n  margin-bottom: 0;\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--colorGray);\n  box-shadow: 0px 3px 6px #00000029;\n  z-index: 9;\n}\nheader .header-right .user button.user-true + .user-list {\n  visibility: visible;\n}\nheader .header-right .user button.user-true + .user-list.show {\n  display: block;\n}\nheader .header-right .user .user-list li {\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n}\nheader .header-right .user .user-list li a {\n  color: var(--colorGray);\n  margin-left: 0;\n}\nheader .header-right .user .user-list li a:hover {\n  color: var(--colorYellow);\n}\nheader .header-right .user .user-list li span {\n  cursor: pointer;\n  color: var(--colorGray);\n}\nheader .header-right .user .user-list li span:hover {\n  color: var(--colorYellow);\n}\nheader .header-right .user .user-list li:not(:last-child) {\n  border-bottom: 1px solid #3d4045;\n}\n/* header - end */\n\n/*modal styles*/\n.modal-content {\n  padding: 3em; /* font-size:.8em; */\n  background: rgba(25, 30, 39, 1);\n  color: #f4f3f2;\n  border: 1px solid #3d4045;\n  border-radius: 0; /* Athena design language uses sharp edges, not curves */\n}\n.modal-content .form-text {\n  font-size: 10px;\n  color: #6c6f74;\n}\n.modal-content .requestdemo {\n  margin-top: -35px;\n}\n/* .modal-content .form-check input{background:transparent;border:1px solid #979A9F;} */\n/* .modal-content  */\n.form-check label {\n  color: #979a9f;\n  transition: top 2s;\n}\n.modal-content .formitem {\n  position: relative;\n}\n.modal-content .formitem .form-label {\n  position: absolute;\n  transition-duration: 1s;\n}\n.modal-content .formitem .form-label.raisedlabel {\n  top: -25px;\n}\n.modal-footer button,\n.modal-footer button:active,\n.modal-footer button:focus {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.modal-footer button:active:hover,\n.modal-footer button:hover {\n  opacity: 0.8;\n}\n.modal-header {\n  border: none;\n  border-bottom: 1px solid rgba(151, 154, 159, 0.25);\n  padding-bottom: 1.25em;\n  margin-bottom: 0.75em;\n}\n.modal-title {\n  color: #fd9f29;\n  font-size: 1.35em;\n  font-weight: 600;\n}\n.modal-footer {\n  border: none;\n  border-top: 1px solid rgba(151, 154, 159, 0.25);\n  justify-content: flex-start;\n  padding-top: 1.25em;\n  margin-top: 0.75em;\n}\n.modal-content .message {\n  font-size: 1.1em;\n  color: #fd9f29;\n}\n/* Form fields inside modals — dark surface + amber focus border, matching the\n   field styling used in UnderwritingEngineV2/portfolio-risk-concentration. */\n.modal-content input[type=\"text\"],\n.modal-content input[type=\"email\"],\n.modal-content input[type=\"password\"],\n.modal-content input[type=\"tel\"],\n.modal-content input[type=\"number\"],\n.modal-content textarea,\n.modal-content select,\n.modal-content .form-select,\n.modal-content .form-control {\n  background-color: #12151b !important;\n  border: 1px solid #3d4045 !important;\n  color: #f4f3f2 !important;\n  border-radius: 0 !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n/* Consistent control height across every modal, so an inline \"Add\" button\n   next to a dropdown/input lines up instead of towering over it. */\n.modal-content select,\n.modal-content .form-select,\n.modal-content input[type=\"text\"],\n.modal-content input[type=\"email\"],\n.modal-content input[type=\"password\"],\n.modal-content input[type=\"tel\"],\n.modal-content input[type=\"number\"],\n.modal-content .form-control:not(textarea) {\n  height: 38px;\n}\n.modal-content input[type=\"text\"]::placeholder,\n.modal-content input[type=\"email\"]::placeholder,\n.modal-content input[type=\"password\"]::placeholder,\n.modal-content input[type=\"tel\"]::placeholder,\n.modal-content input[type=\"number\"]::placeholder,\n.modal-content textarea::placeholder {\n  color: #6c6f74;\n}\n.modal-content input[type=\"text\"]:focus,\n.modal-content input[type=\"email\"]:focus,\n.modal-content input[type=\"password\"]:focus,\n.modal-content input[type=\"tel\"]:focus,\n.modal-content input[type=\"number\"]:focus,\n.modal-content textarea:focus,\n.modal-content select:focus,\n.modal-content .form-select:focus,\n.modal-content .form-control:focus,\n.modal-content input:focus-visible,\n.modal-content select:focus-visible,\n.modal-content textarea:focus-visible {\n  border-color: #fd9f29 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n/* Bootstrap paints red/green borders on required/validated fields\n   independent of focus — flatten those back to our own border color so\n   an empty \"required\" dropdown doesn't show up red/off-brand. */\n.modal-content input:invalid,\n.modal-content input:valid,\n.modal-content select:invalid,\n.modal-content select:valid,\n.modal-content textarea:invalid,\n.modal-content textarea:valid,\n.modal-content .form-control.is-invalid,\n.modal-content .form-control.is-valid,\n.modal-content .form-select.is-invalid,\n.modal-content .form-select.is-valid {\n  border-color: #3d4045 !important;\n  box-shadow: none !important;\n}\n/* Native checkbox/radio \"accent\" color otherwise follows the browser/OS\n   theme (can render as blue, green, or other off-brand colors). */\n.modal-content input[type=\"checkbox\"],\n.modal-content input[type=\"radio\"] {\n  accent-color: #fd9f29;\n}\n/* Chrome/Edge autofill paints its own yellow background + text color;\n   force it back to the dark field styling used everywhere else. */\n.modal-content input:-webkit-autofill,\n.modal-content input:-webkit-autofill:hover,\n.modal-content input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #f4f3f2;\n  -webkit-box-shadow: 0 0 0px 1000px #12151b inset;\n  box-shadow: 0 0 0px 1000px #12151b inset;\n  caret-color: #f4f3f2;\n  transition: background-color 5000s ease-in-out 0s;\n}\n.modal-content select,\n.modal-content .form-select {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+PHBhdGggZD0iTTEgMS41bDUgNSA1LTUiIHN0cm9rZT0iIzk3OWE5ZiIgc3Ryb2tlLXdpZHRoPSIxLjYiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 0.85rem center !important;\n  background-size: 12px 8px !important;\n  padding-right: 2.25rem !important;\n}\n/* Inline \"Add\" button used next to a role/tier picker — height-matched to\n   the 38px control it sits beside, and vertically centered rather than\n   inheriting the app-wide .btn-transparent's larger default padding. */\n.modal-add-btn {\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px !important;\n  margin: 0 !important;\n  white-space: nowrap;\n}\n.modal-content button[type=\"cancel\"] {\n  background: transparent;\n  border: 1px solid #fd9f29;\n  color: #fd9f29;\n}\n.btn-close {\n  background: url(\"./assets/images/icons/modalclose.png\") no-repeat;\n  background-size: cover;\n  position: relative;\n  z-index: 1;\n}\n/* Small uppercase amber section label — the \"eyebrow\" pattern used throughout\n   UnderwritingEngineV2 (e.g. \"Admin · Eligibility\" above \"Guardrails Controller\"). */\n.modal-eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #fd9f29;\n}\n/* Removable role/item chip — replaces the plain gray Bootstrap badge so\n   assigned-role chips match the dark, sharp-edged Athena look. */\n.modal-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  background-color: #191e27;\n  border: 1px solid #3d4045;\n  color: #f4f3f2;\n  border-radius: 0;\n  padding: 0.35em 0.6em;\n  font-size: 0.8em;\n  font-weight: 500;\n}\n.modal-chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.5em;\n  min-height: 1.5em;\n  margin: -0.2em -0.3em -0.2em 0;\n  font-size: 1.15em;\n  line-height: 1;\n  color: #979a9f;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease;\n}\n.modal-chip-remove:hover,\n.modal-chip-remove:focus-visible {\n  color: #ffffff;\n  background-color: #d9364a;\n}\n/*modal styles*/\n\n/* Sharp corners on the app's primary/outline buttons, matching the\n   Athena \"edges, not curves\" design language used across the newer modules. */\nbutton.btn-yellow,\nbutton.btn-transparent,\na.btn-yellow,\na.btn-transparent {\n  border-radius: 0;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n/* Header icon hover styles */\n.header-icon-link {\n  transition: color 0.2s ease, filter 0.2s ease;\n  cursor: pointer;\n}\n\n.header-icon-link:hover {\n  color: var(--colorYellow) !important;\n  filter: grayscale(0%) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
